
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gV7D4", function(module, exports) {
$parcel$export(module.exports, "useActivityClient", function () { return $c517e33112aa8e9d$export$6620595b7f837f8f; });

var $1oC0p = parcelRequire("1oC0p");

var $cOMGU = parcelRequire("cOMGU");

var $kttmz = parcelRequire("kttmz");

var $1KUQX = parcelRequire("1KUQX");
var $c517e33112aa8e9d$export$6620595b7f837f8f = function useActivityClient(version, product, logger, baseUrl) {
    var _useFlightDeckContext = (0, $cOMGU.useFlightDeckContext)(), getArtifact = _useFlightDeckContext.getArtifact;
    return (0, $1oC0p.useMemo)(function() {
        return (0, $1KUQX.createActivityClient)(version, product, logger, baseUrl, // If the rw-client is wrapped in a FD provider, use the provided fetch function
        getArtifact ? function() {
            return getArtifact((0, $kttmz.FD_CLIENT_FETCH_PROPS).name, (0, $kttmz.FD_CLIENT_FETCH_PROPS).dimensions);
        } : undefined);
    }, [
        version,
        product,
        logger,
        baseUrl,
        getArtifact
    ]);
};

});
parcelRegister("cOMGU", function(module, exports) {
$parcel$export(module.exports, "useFlightDeckContext", function () { return $954fec91d2575ca9$export$73c96350a5e69ec; });

var $1oC0p = parcelRequire("1oC0p");

var $37Osf = parcelRequire("37Osf");
const $954fec91d2575ca9$export$ca1b33377afa620 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createContext({
    getArtifact: null
});
function $954fec91d2575ca9$export$56da85ac9d40dbcd({ children: children, product: product, config: config, fallbackArtifacts: fallbackArtifacts }) {
    const flightDeckClient = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useMemo(()=>{
        return new (0, $37Osf.default)(product, {
            handlers: {
                captureException: config === null || config === void 0 ? void 0 : config.captureException
            }
        }, fallbackArtifacts);
    }, [
        product,
        config === null || config === void 0 ? void 0 : config.captureException,
        fallbackArtifacts
    ]);
    const getArtifact = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useCallback(async (name, dimensions)=>{
        return flightDeckClient.fetchConfigFromFlightDeck({
            name: name,
            dimensions: dimensions
        });
    }, [
        flightDeckClient
    ]);
    const providerValue = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useMemo(()=>({
            getArtifact: getArtifact
        }), [
        getArtifact
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($954fec91d2575ca9$export$ca1b33377afa620.Provider, {
        value: providerValue
    }, children);
}
const $954fec91d2575ca9$export$73c96350a5e69ec = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useContext($954fec91d2575ca9$export$ca1b33377afa620);
function $954fec91d2575ca9$export$3b241cde208d2c5e(key, dimensions) {
    const [artifact, setArtifact] = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useState();
    const { getArtifact: getArtifact } = $954fec91d2575ca9$export$73c96350a5e69ec();
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useEffect(()=>{
        if (!getArtifact) throw new Error("Flight Deck Context not provided");
        getArtifact(key, dimensions).then((resp)=>setArtifact(resp))// we don't need to do anything with the error as it is already instrumented in the flightDeckClient
        .catch();
    }, [
        dimensions,
        key,
        getArtifact,
        setArtifact
    ]);
    return artifact;
}

});

parcelRegister("kttmz", function(module, exports) {
$parcel$export(module.exports, "FD_CLIENT_FETCH_PROPS", function () { return $ee7d4afd7031b6cc$export$c270c412a04ff3e6; });
$parcel$export(module.exports, "default", function () { return $ee7d4afd7031b6cc$export$2e2bcd8739ae039; });

var $hd11L = parcelRequire("hd11L");

var $aRrmH = parcelRequire("aRrmH");

var $fCTsg = parcelRequire("fCTsg");

var $gFffs = parcelRequire("gFffs");

var $a9dQv = parcelRequire("a9dQv");

var $37Osf = parcelRequire("37Osf");

var $cDUWS = parcelRequire("cDUWS");
var $ee7d4afd7031b6cc$var$RECENT_WORK_ARTIFACT = 'recent-work-service';
var $ee7d4afd7031b6cc$var$FD_ENVIRONMENT = 'prod';
var $ee7d4afd7031b6cc$export$c270c412a04ff3e6 = {
    name: $ee7d4afd7031b6cc$var$RECENT_WORK_ARTIFACT,
    dimensions: {
        environmentType: $ee7d4afd7031b6cc$var$FD_ENVIRONMENT
    }
};
var $ee7d4afd7031b6cc$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function HydratorConfigClient(handlers, product, artifactFetch) {
        var _this = this;
        (0, $aRrmH.default)(this, HydratorConfigClient);
        (0, $gFffs.default)(this, "fetchConfig", /*#__PURE__*/ (0, $hd11L.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).mark(function _callee() {
            var artifact, fragments, hydrators;
            return (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.next = 2;
                        return _this.fetchArtifact();
                    case 2:
                        artifact = _context.sent;
                        fragments = artifact.queryFragments, hydrators = artifact.hydrators;
                        return _context.abrupt("return", {
                            fragments: fragments,
                            hydrators: hydrators
                        });
                    case 5:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        })));
        this.flightDeck = new (0, $37Osf.default)(product || 'recent-work-client', {
            handlers: handlers
        }, [
            {
                name: 'recent-work-service',
                dimensions: {
                    environmentType: $ee7d4afd7031b6cc$var$FD_ENVIRONMENT
                },
                value: (0, $cDUWS.default)
            }
        ]);
        this.artifactFetch = artifactFetch;
    }
    return (0, $fCTsg.default)(HydratorConfigClient, [
        {
            key: "fetchArtifact",
            value: function() {
                var _fetchArtifact = (0, $hd11L.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).mark(function _callee2() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                if (!this.artifactFetch) {
                                    _context2.next = 2;
                                    break;
                                }
                                return _context2.abrupt("return", this.artifactFetch());
                            case 2:
                                return _context2.abrupt("return", this.flightDeck.fetchConfigFromFlightDeck($ee7d4afd7031b6cc$export$c270c412a04ff3e6, // Retries are for the background refresh, so not too aggressive
                                {
                                    intervalsMS: [
                                        100,
                                        500
                                    ]
                                }));
                            case 3:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function fetchArtifact() {
                    return _fetchArtifact.apply(this, arguments);
                }
                return fetchArtifact;
            }()
        }
    ]);
}();

});
parcelRegister("hd11L", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c8747298e7ff9eab$export$2e2bcd8739ae039; });
function $c8747298e7ff9eab$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $c8747298e7ff9eab$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $c8747298e7ff9eab$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $c8747298e7ff9eab$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("aRrmH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7e8414c580d0ccd7$export$2e2bcd8739ae039; });
function $7e8414c580d0ccd7$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("fCTsg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b6056bcefd74d0b9$export$2e2bcd8739ae039; });

var $hGYgW = parcelRequire("hGYgW");
function $b6056bcefd74d0b9$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $hGYgW.default)(o.key), o);
    }
}
function $b6056bcefd74d0b9$export$2e2bcd8739ae039(e, r, t) {
    return r && $b6056bcefd74d0b9$var$_defineProperties(e.prototype, r), t && $b6056bcefd74d0b9$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("hGYgW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ce151cb572d8ba1f$export$2e2bcd8739ae039; });

var $bYF3k = parcelRequire("bYF3k");

var $bagwh = parcelRequire("bagwh");
function $ce151cb572d8ba1f$export$2e2bcd8739ae039(t) {
    var i = (0, $bagwh.default)(t, "string");
    return "symbol" == (0, $bYF3k.default)(i) ? i : i + "";
}

});
parcelRegister("bYF3k", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8b85247d603954ff$export$2e2bcd8739ae039; });
function $8b85247d603954ff$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $8b85247d603954ff$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8b85247d603954ff$export$2e2bcd8739ae039(o);
}

});

parcelRegister("bagwh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $820d715884c498bb$export$2e2bcd8739ae039; });

var $bYF3k = parcelRequire("bYF3k");
function $820d715884c498bb$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $bYF3k.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $bYF3k.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("gFffs", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c21c4da71d99ea2d$export$2e2bcd8739ae039; });

var $hGYgW = parcelRequire("hGYgW");
function $c21c4da71d99ea2d$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $hGYgW.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});

parcelRegister("a9dQv", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $76357c2925f8124b$var$runtime = (parcelRequire("ep27c"))();
module.exports = $76357c2925f8124b$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $76357c2925f8124b$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $76357c2925f8124b$var$runtime;
    else Function("r", "regeneratorRuntime = r")($76357c2925f8124b$var$runtime);
}

});
parcelRegister("ep27c", function(module, exports) {

var $5LHBX = parcelRequire("5LHBX");

var $UbdVR = parcelRequire("UbdVR");

var $l2PIZ = parcelRequire("l2PIZ");

var $ee2lX = parcelRequire("ee2lX");

var $95CMU = parcelRequire("95CMU");

var $fNSzV = parcelRequire("fNSzV");

var $3i5xW = parcelRequire("3i5xW");
function $a7c50a8380496016$var$_regeneratorRuntime() {
    "use strict";
    var r = $UbdVR(), e = r.m($a7c50a8380496016$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $3i5xW(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $a7c50a8380496016$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $5LHBX(r, e);
            },
            AsyncIterator: $95CMU,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $ee2lX : $l2PIZ)(a(r), e, t, o, u);
            },
            keys: $fNSzV,
            values: $3i5xW
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $a7c50a8380496016$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5LHBX", function(module, exports) {
function $43332bd4ce7089b2$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $43332bd4ce7089b2$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("UbdVR", function(module, exports) {

var $6PUmf = parcelRequire("6PUmf");
function $0a8defdf73adadd2$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $6PUmf(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($6PUmf(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $6PUmf(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $6PUmf(u, "constructor", GeneratorFunctionPrototype), $6PUmf(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $6PUmf(GeneratorFunctionPrototype, o, "GeneratorFunction"), $6PUmf(u), $6PUmf(u, o, "Generator"), $6PUmf(u, n, function() {
        return this;
    }), $6PUmf(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $0a8defdf73adadd2$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $0a8defdf73adadd2$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6PUmf", function(module, exports) {
function $4fa338fa946bdbba$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $4fa338fa946bdbba$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $4fa338fa946bdbba$var$_regeneratorDefine(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $4fa338fa946bdbba$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $4fa338fa946bdbba$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("l2PIZ", function(module, exports) {

var $ee2lX = parcelRequire("ee2lX");
function $f521e84b206319e0$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $ee2lX(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $f521e84b206319e0$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ee2lX", function(module, exports) {

var $UbdVR = parcelRequire("UbdVR");

var $95CMU = parcelRequire("95CMU");
function $a5b432c3f34addd2$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $95CMU($UbdVR().w(r, e, t, o), n || Promise);
}
module.exports = $a5b432c3f34addd2$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("95CMU", function(module, exports) {

var $5LHBX = parcelRequire("5LHBX");

var $6PUmf = parcelRequire("6PUmf");
function $69e2ab2a454677c2$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $5LHBX ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($6PUmf($69e2ab2a454677c2$var$AsyncIterator.prototype), $6PUmf($69e2ab2a454677c2$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $6PUmf(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $69e2ab2a454677c2$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("fNSzV", function(module, exports) {
function $b815c4be1cf4a75b$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $b815c4be1cf4a75b$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3i5xW", function(module, exports) {

var $cvKDJ = parcelRequire("cvKDJ");
var $26575af25eacfc74$var$_typeof = $cvKDJ.default;
function $26575af25eacfc74$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($26575af25eacfc74$var$_typeof(e) + " is not iterable");
}
module.exports = $26575af25eacfc74$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cvKDJ", function(module, exports) {
function $91bc8f024903970e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $91bc8f024903970e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $91bc8f024903970e$var$_typeof(o);
}
module.exports = $91bc8f024903970e$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("cDUWS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $93454d58dfad5016$export$2e2bcd8739ae039; });
var $93454d58dfad5016$export$2e2bcd8739ae039 = {
    localization: {
        eventTypes: {
            commented: {
                absolute: 'You commented on {absoluteTime}',
                relative: 'You commented {relativeTime}',
                standalone: 'You commented',
                multiAbsolute: 'Commented on {absoluteTime}',
                multiRelative: 'Commented {relativeTime}',
                multiStandalone: 'Commented'
            },
            created: {
                absolute: 'You created on {absoluteTime}',
                relative: 'You created {relativeTime}',
                standalone: 'You created',
                multiAbsolute: 'Created on {absoluteTime}',
                multiRelative: 'Created {relativeTime}',
                multiStandalone: 'Created'
            },
            edited: {
                absolute: 'You edited on {absoluteTime}',
                relative: 'You edited {relativeTime}',
                standalone: 'You edited',
                multiAbsolute: 'Edited on {absoluteTime}',
                multiRelative: 'Edited {relativeTime}',
                multiStandalone: 'Edited'
            },
            published: {
                absolute: 'You published on {absoluteTime}',
                relative: 'You published {relativeTime}',
                standalone: 'You published',
                multiAbsolute: 'Published on {absoluteTime}',
                multiRelative: 'Published {relativeTime}',
                multiStandalone: 'Published'
            },
            updated: {
                absolute: 'You updated on {absoluteTime}',
                relative: 'You updated {relativeTime}',
                standalone: 'You updated',
                multiAbsolute: 'Updated on {absoluteTime}',
                multiRelative: 'Updated {relativeTime}',
                multiStandalone: 'Updated'
            },
            viewed: {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            }
        }
    },
    hydrators: {
        TownsquareGoal: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'key'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'iconData'
                ]
            }
        },
        TownsquareProject: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'key'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'iconData'
                ]
            }
        },
        TownsquareComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'container.key'
                ],
                name: [
                    'container.name'
                ],
                url: [
                    'container.url'
                ],
                icon: [
                    'container.iconData'
                ],
                deduplicateId: [
                    'container.id'
                ]
            }
        },
        ConfluencePage: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'pageId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
            }
        },
        ConfluenceBlogPost: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'blogPostId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg'
            }
        },
        ConfluenceComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
            }
        },
        ConfluenceFooterComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
            }
        },
        ConfluenceInlineComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://fd-assets.prod.atl-paas.net/image/misc-icons/confluence/page.svg'
            }
        },
        JiraIssue: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'
                ],
                key: [
                    'key'
                ]
            }
        },
        JiraPlatformComment: {
            hydratorPaths: {
                id: [
                    'commentId'
                ],
                name: [
                    'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'
                ],
                key: [
                    'issue.key'
                ],
                deduplicateId: [
                    'issue.id'
                ]
            }
        },
        JiraServiceManagementComment: {
            hydratorPaths: {
                id: [
                    'commentId'
                ],
                name: [
                    'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.xsmall'
                ],
                key: [
                    'issue.key'
                ],
                deduplicateId: [
                    'issue.id'
                ]
            }
        }
    },
    queryFragments: '\n\n  fragment townsquareGoal on TownsquareGoal {\n    id\n    key\n    name\n    url\n    iconData\n  }\n\n\n  fragment townsquareProject on TownsquareProject {\n    id\n    key\n    name\n    url\n    iconData\n  }\n\n\n  fragment townsquareComment on TownsquareComment {\n    id\n    url\n    container {\n      __typename\n      ...townsquareGoal\n      ...townsquareProject\n    }\n  }\n\n\n  fragment confluencePage on ConfluencePage {\n    id\n    title\n    pageId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceBlogPost on ConfluenceBlogPost {\n    id\n    title\n    blogPostId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceComment on ConfluenceComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\n  fragment confluenceFooterComment on ConfluenceFooterComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\n  fragment confluenceInlineComment on ConfluenceInlineComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n    }\n  }\n\n\nfragment jiraIssue on JiraIssue {\n  id\n  key\n  webUrl\n  fieldsById(ids: ["summary", "issuetype", "project"]) {\n    edges {\n      node {\n        __typename\n        fieldId\n        ...jiraSingleLineTextField\n        ...jiraIssueTypeField\n        ...jiraProjectField\n      }\n    }\n  }\n}\nfragment jiraSingleLineTextField on JiraSingleLineTextField {\n  text\n}\nfragment jiraIssueTypeField on JiraIssueTypeField {\n  issueType {\n    avatar {\n      xsmall\n    }\n  }\n}\nfragment jiraProjectField on JiraProjectField {\n  project {\n    name\n  }\n}\n\n\nfragment jiraPlatformComment on JiraPlatformComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\n\nfragment jiraServiceManagementComment on JiraServiceManagementComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\nfragment activityItemEdge on ActivityItemEdge {\n  cursor\n  node {\n    id\n    object {\n      id\n      type\n      product\n      subProduct\n      rootContainerId\n      contributors {\n        profile {\n          name\n          picture\n          accountId\n        }\n      }\n      data {\n        __typename\n\t...townsquareGoal\n\t...townsquareProject\n\t...townsquareComment\n\t...confluencePage\n\t...confluenceBlogPost\n\t...confluenceComment\n\t...confluenceFooterComment\n\t...confluenceInlineComment\n\t...jiraIssue\n\t...jiraPlatformComment\n\t...jiraServiceManagementComment\n      }\n    }\n    event {\n      id\n      timestamp\n      eventType\n      actor {\n        name\n        picture\n        accountId\n      }\n    }\n  }\n}\nfragment activityItemConnection on ActivityConnection {\n  edges {\n    ...activityItemEdge\n  }\n}\n\n'
};

});


parcelRegister("1KUQX", function(module, exports) {
$parcel$export(module.exports, "createActivityClient", function () { return $1476302f3691ca20$export$224367b01f71f2aa; });

var $70b4e = parcelRequire("70b4e");

var $4zPwD = parcelRequire("4zPwD");
var $1476302f3691ca20$var$previousClientVersion;
var $1476302f3691ca20$export$224367b01f71f2aa = function createActivityClient(version, product, logger, baseUrl, configFetch) {
    if ($1476302f3691ca20$var$previousClientVersion && $1476302f3691ca20$var$previousClientVersion !== version && logger !== null && logger !== void 0 && logger.captureWarning) logger.captureWarning("ActivityClient version has changed, is this intentional?");
    $1476302f3691ca20$var$previousClientVersion = version || 'v3';
    if (version === 'v2') return new (0, $70b4e.ActivityClientV2)(product, baseUrl);
    return new (0, $4zPwD.ActivityClientV3)(product, baseUrl, logger, configFetch);
};

});
parcelRegister("70b4e", function(module, exports) {
$parcel$export(module.exports, "ActivityClientV2", function () { return $51911e35d6e40ecd$export$330ab0047f2fb745; });

var $hd11L = parcelRequire("hd11L");

var $fCTsg = parcelRequire("fCTsg");

var $aRrmH = parcelRequire("aRrmH");

var $6VWyZ = parcelRequire("6VWyZ");

var $bGqVi = parcelRequire("bGqVi");

var $5pRqT = parcelRequire("5pRqT");

var $gFffs = parcelRequire("gFffs");

var $a9dQv = parcelRequire("a9dQv");

var $f4XZt = parcelRequire("f4XZt");

var $hqgpR = parcelRequire("hqgpR");

var $6gfwl = parcelRequire("6gfwl");
function $51911e35d6e40ecd$var$_callSuper(t, o, e) {
    return o = (0, $bGqVi.default)(o), (0, $6VWyZ.default)(t, $51911e35d6e40ecd$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $bGqVi.default)(t).constructor) : o.apply(t, e));
}
function $51911e35d6e40ecd$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($51911e35d6e40ecd$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $51911e35d6e40ecd$export$330ab0047f2fb745 = /*#__PURE__*/ function(_ActivityClient) {
    function ActivityClientV2(_product, baseUrl) {
        var _this;
        (0, $aRrmH.default)(this, ActivityClientV2);
        _this = $51911e35d6e40ecd$var$_callSuper(this, ActivityClientV2, [
            'v2',
            _product,
            undefined,
            baseUrl
        ]);
        (0, $gFffs.default)(_this, "fetchActivities", /*#__PURE__*/ function() {
            var _ref = (0, $hd11L.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).mark(function _callee(retryMS, filters, activityQueries) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            return _context.abrupt("return", (0, $f4XZt.fetchActivitiesWithExperience)(function(experience) {
                                return (0, $6gfwl.fetchActivitiesV2)({
                                    experience: experience,
                                    product: _this.product,
                                    retryMS: retryMS,
                                    filters: filters,
                                    activityQueries: activityQueries,
                                    baseUrl: _this.baseUrl
                                });
                            }, 'v2'));
                        case 1:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x, _x2, _x3) {
                return _ref.apply(this, arguments);
            };
        }());
        (0, $gFffs.default)(_this, "setProduct", function(product) {
            _this.product = product;
        });
        return _this;
    }
    (0, $5pRqT.default)(ActivityClientV2, _ActivityClient);
    return (0, $fCTsg.default)(ActivityClientV2);
}((0, $hqgpR.ActivityClient));

});
parcelRegister("6VWyZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $50c57e66dfb9f361$export$2e2bcd8739ae039; });

var $bYF3k = parcelRequire("bYF3k");

var $fD6hU = parcelRequire("fD6hU");
function $50c57e66dfb9f361$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $bYF3k.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $fD6hU.default)(t);
}

});
parcelRegister("fD6hU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b60f6029111b8cea$export$2e2bcd8739ae039; });
function $b60f6029111b8cea$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("bGqVi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $881880506025e0c2$export$2e2bcd8739ae039; });
function $881880506025e0c2$export$2e2bcd8739ae039(t) {
    return $881880506025e0c2$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $881880506025e0c2$export$2e2bcd8739ae039(t);
}

});

parcelRegister("5pRqT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3f18bc354188ca78$export$2e2bcd8739ae039; });

var $7XCdi = parcelRequire("7XCdi");
function $3f18bc354188ca78$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $7XCdi.default)(t, e);
}

});
parcelRegister("7XCdi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5cbbaf80ee507623$export$2e2bcd8739ae039; });
function $5cbbaf80ee507623$export$2e2bcd8739ae039(t, e) {
    return $5cbbaf80ee507623$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $5cbbaf80ee507623$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("f4XZt", function(module, exports) {
$parcel$export(module.exports, "fetchActivitiesWithExperience", function () { return $afa5c39692fb149f$export$4a906f16800734f3; });

var $gFffs = parcelRequire("gFffs");

var $hd11L = parcelRequire("hd11L");

var $a9dQv = parcelRequire("a9dQv");

var $6tfcl = parcelRequire("6tfcl");

var $bmweo = parcelRequire("bmweo");

var $4jJEe = parcelRequire("4jJEe");
function $afa5c39692fb149f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $afa5c39692fb149f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $afa5c39692fb149f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gFffs.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $afa5c39692fb149f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $afa5c39692fb149f$export$4a906f16800734f3(_x, _x2) {
    return $afa5c39692fb149f$var$_fetchActivitiesWithExperience.apply(this, arguments);
}
function $afa5c39692fb149f$var$_fetchActivitiesWithExperience() {
    $afa5c39692fb149f$var$_fetchActivitiesWithExperience = (0, $hd11L.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).mark(function _callee(fetchActivities, clientVersion) {
        var experience, data;
        return (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    experience = clientVersion === 'v2' ? (0, $4jJEe.recentWorkClientExperienceV2)() : (0, $4jJEe.recentWorkClientExperienceV3)();
                    _context.prev = 1;
                    experience.start();
                    experience.addMetadata({
                        clientVersion: clientVersion,
                        packageName: (0, $bmweo.packageName),
                        packageVersion: (0, $bmweo.packageVersion)
                    });
                    _context.next = 6;
                    return fetchActivities(experience);
                case 6:
                    data = _context.sent;
                    experience.success();
                    return _context.abrupt("return", data);
                case 11:
                    _context.prev = 11;
                    _context.t0 = _context["catch"](1);
                    experience.failure({
                        metadata: {
                            error: $afa5c39692fb149f$export$f33622abb5224195(_context.t0)
                        }
                    });
                    throw _context.t0;
                case 15:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                1,
                11
            ]
        ]);
    }));
    return $afa5c39692fb149f$var$_fetchActivitiesWithExperience.apply(this, arguments);
}
var $afa5c39692fb149f$export$f33622abb5224195 = function exceptionToMetadata(e) {
    if (e instanceof (0, $6tfcl.default)) {
        var _e$xRequestId;
        return $afa5c39692fb149f$var$_objectSpread($afa5c39692fb149f$var$_objectSpread({}, e), {}, {
            xRequestId: (_e$xRequestId = e.xRequestId) !== null && _e$xRequestId !== void 0 ? _e$xRequestId : undefined,
            cause: undefined
        });
    }
    return e instanceof Error ? $afa5c39692fb149f$var$_objectSpread($afa5c39692fb149f$var$_objectSpread({}, e), {}, {
        cause: undefined
    }) : 'unknown';
};

});
parcelRegister("6tfcl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4b613d84cb775990$export$2e2bcd8739ae039; });

var $fCTsg = parcelRequire("fCTsg");

var $aRrmH = parcelRequire("aRrmH");

var $6VWyZ = parcelRequire("6VWyZ");

var $bGqVi = parcelRequire("bGqVi");

var $5pRqT = parcelRequire("5pRqT");

var $7DNMr = parcelRequire("7DNMr");
function $4b613d84cb775990$var$_callSuper(t, o, e) {
    return o = (0, $bGqVi.default)(o), (0, $6VWyZ.default)(t, $4b613d84cb775990$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $bGqVi.default)(t).constructor) : o.apply(t, e));
}
function $4b613d84cb775990$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($4b613d84cb775990$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $4b613d84cb775990$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    function HttpError(_ref) {
        var _this;
        var message = _ref.message, statusCode = _ref.statusCode, path = _ref.path, method = _ref.method, xRequestId = _ref.xRequestId, headers = _ref.headers;
        (0, $aRrmH.default)(this, HttpError);
        _this = $4b613d84cb775990$var$_callSuper(this, HttpError);
        _this.name = 'HttpError';
        _this.message = message;
        var p = path.split('?')[0];
        _this.path = /^[/-a-z]+$/i.test(p) ? p : '';
        _this.method = method;
        _this.statusCode = statusCode;
        _this.xRequestId = xRequestId;
        // @ts-ignore - Property 'entries' does not exist on type 'Headers'.
        // This was added when enrolling `@atlassian/recent-work-client` into JFE local consumption
        _this.headers = Array.from(headers.entries()).map(function(value, key) {
            return "".concat(key, ":").concat(value);
        }).sort().join(',');
        return _this;
    }
    (0, $5pRqT.default)(HttpError, _Error);
    return (0, $fCTsg.default)(HttpError);
}(/*#__PURE__*/ (0, $7DNMr.default)(Error));
var $4b613d84cb775990$export$97b788730ba59845 = function isHttpError(e) {
    return e instanceof $4b613d84cb775990$export$2e2bcd8739ae039;
};

});
parcelRegister("7DNMr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5902ca4228e88864$export$2e2bcd8739ae039; });

var $bGqVi = parcelRequire("bGqVi");

var $7XCdi = parcelRequire("7XCdi");

var $hy81a = parcelRequire("hy81a");

var $3YuW8 = parcelRequire("3YuW8");
function $5902ca4228e88864$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $5902ca4228e88864$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $hy81a.default)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $3YuW8.default)(t, arguments, (0, $bGqVi.default)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $7XCdi.default)(Wrapper, t);
    }, $5902ca4228e88864$export$2e2bcd8739ae039(t);
}

});
parcelRegister("hy81a", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cc6bd4d66bcea2e5$export$2e2bcd8739ae039; });
function $cc6bd4d66bcea2e5$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}

});

parcelRegister("3YuW8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2e4ef91391dac18b$export$2e2bcd8739ae039; });

var $a7ha9 = parcelRequire("a7ha9");

var $7XCdi = parcelRequire("7XCdi");
function $2e4ef91391dac18b$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $a7ha9.default)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $7XCdi.default)(p, r.prototype), p;
}

});
parcelRegister("a7ha9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $75d7defd1bba73c6$export$2e2bcd8739ae039; });
function $75d7defd1bba73c6$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($75d7defd1bba73c6$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});




parcelRegister("bmweo", function(module, exports) {
$parcel$export(module.exports, "packageName", function () { return $845ac03352a14b07$export$9345d7360ffe0722; });
$parcel$export(module.exports, "packageVersion", function () { return $845ac03352a14b07$export$91546b032799aa40; });
var $845ac03352a14b07$export$9345d7360ffe0722 = "@atlassian/recent-work-client";
var $845ac03352a14b07$export$91546b032799aa40 = "1.11.0";

});

parcelRegister("4jJEe", function(module, exports) {
$parcel$export(module.exports, "recentWorkClientExperienceV2", function () { return $324c5883fd879e03$export$d7769758f5eaa63b; });
$parcel$export(module.exports, "recentWorkClientExperienceV3", function () { return $324c5883fd879e03$export$9e32a4ed888f4717; });

var $exy8S = parcelRequire("exy8S");
var $edn2O = parcelRequire("edn2O");
var $324c5883fd879e03$var$keyToTiming = function keyToTiming(key) {
    return {
        key: key,
        startMark: "".concat(key, "_start"),
        endMark: "".concat(key, "_end")
    };
};
var $324c5883fd879e03$var$timings = [
    'FetchedActivities',
    'TransformedActivityItems',
    'GeneratedQueryWithFilters'
].map($324c5883fd879e03$var$keyToTiming);
var $324c5883fd879e03$export$d7769758f5eaa63b = function recentWorkClientExperienceV2() {
    return new (0, $edn2O.UFOExperience)('client', {
        type: (0, $exy8S.ExperienceTypes).Load,
        performanceType: (0, $exy8S.ExperiencePerformanceTypes).Custom,
        platform: {
            component: 'recent-work'
        },
        timings: $324c5883fd879e03$var$timings
    });
};
var $324c5883fd879e03$export$9e32a4ed888f4717 = function recentWorkClientExperienceV3() {
    return new (0, $edn2O.UFOExperience)('client-v3', {
        type: (0, $exy8S.ExperienceTypes).Load,
        performanceType: (0, $exy8S.ExperiencePerformanceTypes).Custom,
        platform: {
            component: 'recent-work'
        },
        timings: $324c5883fd879e03$var$timings
    });
};

});
parcelRegister("exy8S", function(module, exports) {
$parcel$export(module.exports, "ExperienceTypes", function () { return $a95ea1aed6d4dc44$export$994164cf3ae1cc9a; });
$parcel$export(module.exports, "ExperiencePerformanceTypes", function () { return $a95ea1aed6d4dc44$export$cc26007c03242fff; });
var $a95ea1aed6d4dc44$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $a95ea1aed6d4dc44$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("edn2O", function(module, exports) {
$parcel$export(module.exports, "UFOExperience", function () { return $a59427b64d07d14a$export$c00d22927c60484a; });

var $fCTsg = parcelRequire("fCTsg");

var $aRrmH = parcelRequire("aRrmH");

var $5pRqT = parcelRequire("5pRqT");

var $6VWyZ = parcelRequire("6VWyZ");

var $bGqVi = parcelRequire("bGqVi");

var $1pVvW = parcelRequire("1pVvW");
function $a59427b64d07d14a$var$_createSuper(t) {
    var r = $a59427b64d07d14a$var$_isNativeReflectConstruct();
    return function() {
        var e, o = (0, $bGqVi.default)(t);
        if (r) {
            var s = (0, $bGqVi.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $6VWyZ.default)(this, e);
    };
}
function $a59427b64d07d14a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a59427b64d07d14a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $a59427b64d07d14a$export$c00d22927c60484a = /*#__PURE__*/ function(_UFOAbstractExperienc) {
    (0, $5pRqT.default)(UFOExperience, _UFOAbstractExperienc);
    var _super = $a59427b64d07d14a$var$_createSuper(UFOExperience);
    function UFOExperience() {
        (0, $aRrmH.default)(this, UFOExperience);
        return _super.apply(this, arguments);
    }
    return (0, $fCTsg.default)(UFOExperience);
}((0, $1pVvW.UFOAbstractExperience));

});
parcelRegister("1pVvW", function(module, exports) {
$parcel$export(module.exports, "UFOAbstractExperience", function () { return $1084bd607500efb9$export$d31c89db257648c; });

var $ivoqu = parcelRequire("ivoqu");

var $hd11L = parcelRequire("hd11L");

var $aRrmH = parcelRequire("aRrmH");

var $fCTsg = parcelRequire("fCTsg");

var $gFffs = parcelRequire("gFffs");

var $a9dQv = parcelRequire("a9dQv");

var $7ClvB = parcelRequire("7ClvB");

var $bUjPg = parcelRequire("bUjPg");

var $lSX13 = parcelRequire("lSX13");

var $bpZXt = parcelRequire("bpZXt");

var $631GR = parcelRequire("631GR");

var $1naES = parcelRequire("1naES");

var $8QX85 = parcelRequire("8QX85");

var $efeDA = parcelRequire("efeDA");

var $1sPvo = parcelRequire("1sPvo");

var $lw61j = parcelRequire("lw61j");

var $exy8S = parcelRequire("exy8S");
function $1084bd607500efb9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1084bd607500efb9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1084bd607500efb9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gFffs.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1084bd607500efb9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1084bd607500efb9$var$getPageVisibleState = function getPageVisibleState() {
    return !(0, $lSX13.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $8QX85.PageVisibleState).VISIBLE : (0, $8QX85.PageVisibleState).HIDDEN;
};
var $1084bd607500efb9$export$c753e8669d30c8ad = function perfNowOrTimestamp(timestamp) {
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $efeDA.roundPerfNow)();
};
var $1084bd607500efb9$export$d31c89db257648c = /*#__PURE__*/ function() {
    function UFOAbstractExperience(id, config) {
        var _this = this;
        var instanceId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        (0, $aRrmH.default)(this, UFOAbstractExperience);
        (0, $gFffs.default)(this, "state", (0, $1sPvo.UFOExperienceState).NOT_STARTED);
        (0, $gFffs.default)(this, "instanceId", null);
        // for concurrent
        (0, $gFffs.default)(this, "parent", null);
        (0, $gFffs.default)(this, "category", null);
        (0, $gFffs.default)(this, "metadata", {});
        (0, $gFffs.default)(this, "onDoneCallbacks", []);
        (0, $gFffs.default)(this, "childExperiences", []);
        (0, $gFffs.default)(this, "explicitTimings", {});
        // @todo move to page load experience when proper classes/inheritance prepared
        (0, $gFffs.default)(this, "isSSROutputAsFMP", false);
        (0, $gFffs.default)(this, "uuid", null);
        (0, $gFffs.default)(this, "_until", null);
        (0, $gFffs.default)(this, "metrics", {
            startTime: null,
            endTime: null,
            marks: []
        });
        (0, $gFffs.default)(this, "performanceConfig", {});
        (0, $gFffs.default)(this, "setPageVisibleStateToMixed", function() {
            _this.pageVisibleState = (0, $8QX85.PageVisibleState).MIXED;
            (0, $1naES.visibilityChangeObserver).unsubscribe(_this.setPageVisibleStateToMixed);
        });
        this.id = id;
        this.category = (config === null || config === void 0 ? void 0 : config.category) || null;
        this.until = (config === null || config === void 0 ? void 0 : config.until) || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $1084bd607500efb9$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $exy8S.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $exy8S.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    (0, $fCTsg.default)(UFOAbstractExperience, [
        {
            key: "transition",
            value: function() {
                var _transition = (0, $hd11L.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).mark(function _callee(newState, timestamp) {
                    var data;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                (0, $631GR.ufolog)('async transition', this.id, this.state.id, newState.id);
                                if (!(0, $lw61j.canTransition)(this.state, newState)) {
                                    _context.next = 15;
                                    break;
                                }
                                (0, $631GR.ufolog)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " successful"), this.state.final, !newState.final);
                                if (newState === (0, $1sPvo.UFOExperienceState).STARTED) this._reset();
                                if (this.state.final && !newState.final) {
                                    this.metrics.startTime = $1084bd607500efb9$export$c753e8669d30c8ad(timestamp);
                                    this.uuid = (0, $7ClvB.v4)();
                                }
                                this.state = newState;
                                if (!newState.final) {
                                    _context.next = 14;
                                    break;
                                }
                                this.metrics.endTime = $1084bd607500efb9$export$c753e8669d30c8ad(timestamp);
                                if (!this._isManualStateEnabled()) (0, $bpZXt.getGlobalEventStream)().push((0, $bpZXt.unsubscribeEvent)((0, $8QX85.SUBSCRIBE_ALL), this.handleDoneBind));
                                _context.next = 11;
                                return this.exportData();
                            case 11:
                                data = _context.sent;
                                (0, $631GR.ufolog)('this.parent', this.parent);
                                (0, $bpZXt.getGlobalEventStream)().push((0, $bpZXt.experiencePayloadEvent)(data));
                            case 14:
                                return _context.abrupt("return", true);
                            case 15:
                                (0, $631GR.ufolog)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " unsuccessful"));
                                (0, $631GR.ufowarn)("transition of ".concat(this.id, " from ").concat(this.state, " to ").concat(newState, " is not possible"));
                                return _context.abrupt("return", false);
                            case 18:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function transition(_x, _x2) {
                    return _transition.apply(this, arguments);
                }
                return transition;
            }()
        },
        {
            key: "start",
            value: function() {
                var _start = (0, $hd11L.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).mark(function _callee2(startTime) {
                    var transitionSuccessful;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.transition((0, $1sPvo.UFOExperienceState).STARTED, startTime);
                            case 2:
                                transitionSuccessful = _context2.sent;
                                if (transitionSuccessful) {
                                    this.pageVisibleState = $1084bd607500efb9$var$getPageVisibleState();
                                    (0, $1naES.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
                                    if (!this._isManualStateEnabled()) {
                                        (0, $631GR.ufolog)('subscribed', this.id);
                                        (0, $bpZXt.getGlobalEventStream)().push((0, $bpZXt.subscribeEvent)((0, $8QX85.SUBSCRIBE_ALL), this.handleDoneBind));
                                    }
                                }
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function start(_x3) {
                    return _start.apply(this, arguments);
                }
                return start;
            }()
        },
        {
            key: "mark",
            value: function mark(name, timestamp) {
                if (name !== (0, $8QX85.FMP_MARK) && name !== (0, $8QX85.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
                else (0, $631GR.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
            }
        },
        {
            key: "_mark",
            value: function _mark(name, timestamp) {
                this.metrics.marks.push({
                    name: name,
                    time: $1084bd607500efb9$export$c753e8669d30c8ad(timestamp)
                });
                this.transition((0, $1sPvo.UFOExperienceState).IN_PROGRESS);
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                this._mark((0, $8QX85.FMP_MARK), timestamp);
            }
        },
        {
            key: "markInlineResponse",
            value: function markInlineResponse(timestamp) {
                this._mark((0, $8QX85.INLINE_RESPONSE_MARK), timestamp);
            }
        },
        {
            key: "_isManualStateEnabled",
            value: function _isManualStateEnabled() {
                return this.until === null;
            }
        },
        {
            key: "_validateManualState",
            value: function _validateManualState() {
                if (!this._isManualStateEnabled()) {
                    (0, $631GR.ufowarn)('manual change of state not allowed as "until" is defined');
                    return false;
                }
                return true;
            }
        },
        {
            key: "switchToEndState",
            value: function switchToEndState(state, config) {
                if (!(config !== null && config !== void 0 && config.force) && !this._validateManualState()) return null;
                if (config !== null && config !== void 0 && config.metadata) this.addMetadata(config.metadata);
                (0, $1naES.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
                return this.transition(state);
            }
        },
        {
            key: "success",
            value: function() {
                var _success = (0, $hd11L.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).mark(function _callee3(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", this.switchToEndState((0, $1sPvo.UFOExperienceState).SUCCEEDED, config));
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function success(_x4) {
                    return _success.apply(this, arguments);
                }
                return success;
            }()
        },
        {
            key: "failure",
            value: function() {
                var _failure = (0, $hd11L.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).mark(function _callee4(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                return _context4.abrupt("return", this.switchToEndState((0, $1sPvo.UFOExperienceState).FAILED, config));
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function failure(_x5) {
                    return _failure.apply(this, arguments);
                }
                return failure;
            }()
        },
        {
            key: "abort",
            value: function() {
                var _abort = (0, $hd11L.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).mark(function _callee5(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                return _context5.abrupt("return", this.switchToEndState((0, $1sPvo.UFOExperienceState).ABORTED, config));
                            case 1:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function abort(_x6) {
                    return _abort.apply(this, arguments);
                }
                return abort;
            }()
        },
        {
            key: "addMetadata",
            value: function addMetadata(data) {
                Object.assign(this.metadata, data);
            }
        },
        {
            key: "_handleDoneExperience",
            value: function _handleDoneExperience(data) {
                (0, $631GR.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
                if (data.state.final) {
                    if (this._until !== null) {
                        var _this$_until = this._until(data), done = _this$_until.done, state = _this$_until.state;
                        if (done && !this.state.final) this.transition(state);
                    }
                }
            }
        },
        {
            key: "getId",
            value: function() {
                var _getId = (0, $hd11L.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).mark(function _callee6() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                return _context6.abrupt("return", this.id);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function getId() {
                    return _getId.apply(this, arguments);
                }
                return getId;
            }()
        },
        {
            key: "exportData",
            value: function() {
                var _exportData = (0, $hd11L.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                _context7.next = 2;
                                return this.getId();
                            case 2:
                                _context7.t0 = _context7.sent;
                                _context7.t1 = this.uuid;
                                _context7.t2 = this.type;
                                _context7.t3 = (0, $bUjPg.UFO_EXPERIMENTAL_BUILD_VERSION) || 'unknown';
                                _context7.t4 = this.performanceType;
                                _context7.t5 = this.category;
                                _context7.t6 = this.state;
                                _context7.t7 = $1084bd607500efb9$var$_objectSpread({}, this.metadata);
                                _context7.t8 = $1084bd607500efb9$var$_objectSpread({}, this.metrics);
                                _context7.t9 = (0, $ivoqu.default)(this.childExperiences);
                                _context7.t10 = {
                                    success: !!this.state.success,
                                    startTime: this.metrics.startTime,
                                    duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
                                };
                                _context7.t11 = this.config.platform || null;
                                _context7.t12 = this.pageVisibleState;
                                _context7.t13 = this.featureFlags;
                                _context7.t14 = this.isSSROutputAsFMP;
                                _context7.t15 = this.timings;
                                _context7.t16 = this.explicitTimings;
                                _context7.t17 = this.performanceConfig;
                                return _context7.abrupt("return", {
                                    id: _context7.t0,
                                    uuid: _context7.t1,
                                    type: _context7.t2,
                                    schemaVersion: _context7.t3,
                                    performanceType: _context7.t4,
                                    category: _context7.t5,
                                    state: _context7.t6,
                                    metadata: _context7.t7,
                                    metrics: _context7.t8,
                                    children: _context7.t9,
                                    result: _context7.t10,
                                    platform: _context7.t11,
                                    pageVisibleState: _context7.t12,
                                    featureFlags: _context7.t13,
                                    isSSROutputAsFMP: _context7.t14,
                                    timings: _context7.t15,
                                    explicitTimings: _context7.t16,
                                    performanceConfig: _context7.t17
                                });
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function exportData() {
                    return _exportData.apply(this, arguments);
                }
                return exportData;
            }()
        },
        {
            key: "_reset",
            value: function _reset() {
                this.parent = null;
                this.metadata = {};
                this.onDoneCallbacks = [];
                this.childExperiences = [];
                this.metrics = {
                    startTime: null,
                    endTime: null,
                    marks: []
                };
                this._until = this.until ? this.until() : null;
            }
        }
    ]);
    return UFOAbstractExperience;
}();

});
parcelRegister("ivoqu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d78e11cb760bd0ba$export$2e2bcd8739ae039; });

var $kTyh3 = parcelRequire("kTyh3");

var $3Ye1m = parcelRequire("3Ye1m");

var $k05Cj = parcelRequire("k05Cj");

var $66ZHl = parcelRequire("66ZHl");
function $d78e11cb760bd0ba$export$2e2bcd8739ae039(r) {
    return (0, $kTyh3.default)(r) || (0, $3Ye1m.default)(r) || (0, $k05Cj.default)(r) || (0, $66ZHl.default)();
}

});
parcelRegister("kTyh3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f36387d06c80150c$export$2e2bcd8739ae039; });

var $kWYDi = parcelRequire("kWYDi");
function $f36387d06c80150c$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $kWYDi.default)(r);
}

});
parcelRegister("kWYDi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f40841db8e44490e$export$2e2bcd8739ae039; });
function $f40841db8e44490e$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("3Ye1m", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2e41d9f123936242$export$2e2bcd8739ae039; });
function $2e41d9f123936242$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("k05Cj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e8f82a1df56bb818$export$2e2bcd8739ae039; });

var $kWYDi = parcelRequire("kWYDi");
function $e8f82a1df56bb818$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $kWYDi.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $kWYDi.default)(r, a) : void 0;
    }
}

});

parcelRegister("66ZHl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $47332996ecd93164$export$2e2bcd8739ae039; });
function $47332996ecd93164$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("7ClvB", function(module, exports) {

var $kDxb0 = parcelRequire("kDxb0");

var $gqRFp = parcelRequire("gqRFp");
var $58bcc437ecb0573d$var$uuid = $gqRFp;
$58bcc437ecb0573d$var$uuid.v1 = $kDxb0;
$58bcc437ecb0573d$var$uuid.v4 = $gqRFp;
module.exports = $58bcc437ecb0573d$var$uuid;

});
parcelRegister("kDxb0", function(module, exports) {

var $3n19L = parcelRequire("3n19L");

var $7hqHV = parcelRequire("7hqHV");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $f0612f5722e69906$var$_nodeId;
var $f0612f5722e69906$var$_clockseq;
// Previous uuid creation time
var $f0612f5722e69906$var$_lastMSecs = 0;
var $f0612f5722e69906$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $f0612f5722e69906$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $f0612f5722e69906$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $f0612f5722e69906$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $3n19L();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $f0612f5722e69906$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $f0612f5722e69906$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $f0612f5722e69906$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $f0612f5722e69906$var$_lastMSecs + (nsecs - $f0612f5722e69906$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $f0612f5722e69906$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $f0612f5722e69906$var$_lastMSecs = msecs;
    $f0612f5722e69906$var$_lastNSecs = nsecs;
    $f0612f5722e69906$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $7hqHV(b);
}
module.exports = $f0612f5722e69906$var$v1;

});
parcelRegister("3n19L", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $27446ab697bddb5a$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($27446ab697bddb5a$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $27446ab697bddb5a$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $27446ab697bddb5a$var$getRandomValues($27446ab697bddb5a$var$rnds8);
        return $27446ab697bddb5a$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $27446ab697bddb5a$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $27446ab697bddb5a$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $27446ab697bddb5a$var$rnds;
    };
}

});

parcelRegister("7hqHV", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $54ced67b03ce93b5$var$byteToHex = [];
for(var $54ced67b03ce93b5$var$i = 0; $54ced67b03ce93b5$var$i < 256; ++$54ced67b03ce93b5$var$i)$54ced67b03ce93b5$var$byteToHex[$54ced67b03ce93b5$var$i] = ($54ced67b03ce93b5$var$i + 0x100).toString(16).substr(1);
function $54ced67b03ce93b5$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $54ced67b03ce93b5$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $54ced67b03ce93b5$var$bytesToUuid;

});


parcelRegister("gqRFp", function(module, exports) {

var $3n19L = parcelRequire("3n19L");

var $7hqHV = parcelRequire("7hqHV");
function $bf68b4309ff61307$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $3n19L)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $7hqHV(rnds);
}
module.exports = $bf68b4309ff61307$var$v4;

});


parcelRegister("bUjPg", function(module, exports) {
$parcel$export(module.exports, "UFO_EXPERIMENTAL_BUILD_VERSION", function () { return $8ab44daee64ff22f$export$2295b861f318254a; });
// temp solution until we can get it automated
var $8ab44daee64ff22f$export$2295b861f318254a = '0.1.5';

});

parcelRegister("lSX13", function(module, exports) {
$parcel$export(module.exports, "isWindowObjectAvailable", function () { return $feec6b7a32ace375$export$15e172712955e18f; });
var $feec6b7a32ace375$export$15e172712955e18f = function isWindowObjectAvailable() {
    return typeof window !== 'undefined';
};

});

parcelRegister("bpZXt", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventStream", function () { return $850217257f5f22bc$export$6123a44dc2384540; });
$parcel$export(module.exports, "subscribeEvent", function () { return $850217257f5f22bc$export$37863216db4b714d; });
$parcel$export(module.exports, "unsubscribeEvent", function () { return $850217257f5f22bc$export$ee1a7bd1fc9ea85e; });
$parcel$export(module.exports, "experiencePayloadEvent", function () { return $850217257f5f22bc$export$7c957416596ca127; });

var $631GR = parcelRequire("631GR");

var $8QX85 = parcelRequire("8QX85");
var $850217257f5f22bc$var$MAX_EARLY_QUEUE_LENGTH = 250;
var $850217257f5f22bc$export$6123a44dc2384540 = function getGlobalEventStream() {
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        var earlyStream = function() {
            var stream = [];
            return {
                __buffer_only__: true,
                push: function push(event) {
                    if (stream.length < $850217257f5f22bc$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: function getStream() {
                    return stream;
                }
            };
        }();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
var $850217257f5f22bc$export$c1522520b417b066 = function setGlobalEventStream(eventStream) {
    var _globalThis$__UFO_GLO, _globalThis$__UFO_GLO2;
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !((_globalThis$__UFO_GLO = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO !== void 0 && _globalThis$__UFO_GLO.__buffer_only__)) {
        (0, $631GR.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if ((_globalThis$__UFO_GLO2 = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO2 !== void 0 && _globalThis$__UFO_GLO2.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
var $850217257f5f22bc$export$37863216db4b714d = function subscribeEvent(experienceId, callback) {
    return {
        type: (0, $8QX85.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $850217257f5f22bc$export$ee1a7bd1fc9ea85e = function unsubscribeEvent(experienceId, callback) {
    return {
        type: (0, $8QX85.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $850217257f5f22bc$export$7c957416596ca127 = function experiencePayloadEvent(data) {
    return {
        type: (0, $8QX85.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("631GR", function(module, exports) {
$parcel$export(module.exports, "ufolog", function () { return $4674558859cea609$export$b4958caff08a0960; });
$parcel$export(module.exports, "ufowarn", function () { return $4674558859cea609$export$d53d07b6034c4560; });

var $aRrmH = parcelRequire("aRrmH");

var $fCTsg = parcelRequire("fCTsg");

var $gFffs = parcelRequire("gFffs");
var $4674558859cea609$var$UFOLogger = /*#__PURE__*/ function() {
    function UFOLogger() {
        (0, $aRrmH.default)(this, UFOLogger);
        (0, $gFffs.default)(this, "enabled", false);
    }
    (0, $fCTsg.default)(UFOLogger, [
        {
            key: "log",
            value: function log() {
                var _console;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                // eslint-disable-next-line no-console
                this.enabled && (_console = console).log.apply(_console, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "warn",
            value: function warn() {
                var _console2;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                // eslint-disable-next-line no-console
                this.enabled && (_console2 = console).warn.apply(_console2, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "enable",
            value: function enable() {
                this.enabled = true;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this.enabled = false;
            }
        }
    ]);
    return UFOLogger;
}();
(0, $gFffs.default)($4674558859cea609$var$UFOLogger, "UFOprefix", "[ufo\uD83D\uDEF8]");
var $4674558859cea609$export$4ab84f6f04f6566d = new $4674558859cea609$var$UFOLogger();
var $4674558859cea609$export$b4958caff08a0960 = function ufolog() {
    $4674558859cea609$export$4ab84f6f04f6566d.log.apply($4674558859cea609$export$4ab84f6f04f6566d, arguments);
};
var $4674558859cea609$export$d53d07b6034c4560 = function ufowarn() {
    $4674558859cea609$export$4ab84f6f04f6566d.warn.apply($4674558859cea609$export$4ab84f6f04f6566d, arguments);
};

});

parcelRegister("8QX85", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStreamEventType", function () { return $67210bee74e8c90e$export$96253c35c37cf96b; });
$parcel$export(module.exports, "PageVisibleState", function () { return $67210bee74e8c90e$export$a12c67b37a306b13; });
$parcel$export(module.exports, "SUBSCRIBE_ALL", function () { return $67210bee74e8c90e$export$79bf131685ad41d7; });
$parcel$export(module.exports, "FMP_MARK", function () { return $67210bee74e8c90e$export$9f2bf58999404c75; });
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", function () { return $67210bee74e8c90e$export$837e0f79a8056912; });
var $67210bee74e8c90e$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $67210bee74e8c90e$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $67210bee74e8c90e$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $67210bee74e8c90e$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $67210bee74e8c90e$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $67210bee74e8c90e$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
var $67210bee74e8c90e$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
var $67210bee74e8c90e$export$9f2bf58999404c75 = 'fmp';
var $67210bee74e8c90e$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("1naES", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", function () { return $100034ebf032be4d$export$13e680397ec8f3eb; });

var $aRrmH = parcelRequire("aRrmH");

var $fCTsg = parcelRequire("fCTsg");

var $gFffs = parcelRequire("gFffs");

var $lSX13 = parcelRequire("lSX13");
var $100034ebf032be4d$var$VisibilityChangeObserver = /*#__PURE__*/ function() {
    function VisibilityChangeObserver() {
        var _this = this;
        (0, $aRrmH.default)(this, VisibilityChangeObserver);
        (0, $gFffs.default)(this, "started", false);
        (0, $gFffs.default)(this, "observers", []);
        (0, $gFffs.default)(this, "broadcast", function() {
            _this.observers.forEach(function(fn) {
                return fn();
            });
            _this.observers = [];
        });
    }
    (0, $fCTsg.default)(VisibilityChangeObserver, [
        {
            key: "start",
            value: function start() {
                if (this.started) return;
                this.started = true;
                document.addEventListener('visibilitychange', this.broadcast);
                /**
       * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
       * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
       * so for that case, you need to also include code to listen for the pagehide event.
       */ if ((0, $lSX13.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                this.observers.push(callback);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(callback) {
                this.observers = this.observers.filter(function(fn) {
                    return fn !== callback;
                });
            }
        }
    ]);
    return VisibilityChangeObserver;
}();
var $100034ebf032be4d$export$13e680397ec8f3eb = new $100034ebf032be4d$var$VisibilityChangeObserver();

});

parcelRegister("efeDA", function(module, exports) {
$parcel$export(module.exports, "roundPerfNow", function () { return $a5edd216c26ead39$export$5f490af6b2b115cf; });
var $a5edd216c26ead39$export$5f490af6b2b115cf = function roundPerfNow() {
    return ~~performance.now();
};

});

parcelRegister("1sPvo", function(module, exports) {
$parcel$export(module.exports, "UFOExperienceState", function () { return $11105bdd531249ff$export$81b70111112841a0; });
var $11105bdd531249ff$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    // isn't recovered IN_PROGRESS?
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("lw61j", function(module, exports) {
$parcel$export(module.exports, "canTransition", function () { return $faa141a145d9a8bc$export$178881f329fdb81f; });

var $gFffs = parcelRequire("gFffs");

var $1sPvo = parcelRequire("1sPvo");
var $faa141a145d9a8bc$var$_UFOStateAvailableTra;
var $faa141a145d9a8bc$var$UFOStateAvailableTransitions = ($faa141a145d9a8bc$var$_UFOStateAvailableTra = {}, (0, $gFffs.default)($faa141a145d9a8bc$var$_UFOStateAvailableTra, (0, $1sPvo.UFOExperienceState).NOT_STARTED.id, [
    (0, $1sPvo.UFOExperienceState).STARTED.id
]), (0, $gFffs.default)($faa141a145d9a8bc$var$_UFOStateAvailableTra, (0, $1sPvo.UFOExperienceState).STARTED.id, [
    (0, $1sPvo.UFOExperienceState).IN_PROGRESS.id,
    (0, $1sPvo.UFOExperienceState).BLOCKED.id,
    (0, $1sPvo.UFOExperienceState).SUCCEEDED.id,
    (0, $1sPvo.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $1sPvo.UFOExperienceState).FAILED.id,
    (0, $1sPvo.UFOExperienceState).ABORTED.id
]), (0, $gFffs.default)($faa141a145d9a8bc$var$_UFOStateAvailableTra, (0, $1sPvo.UFOExperienceState).IN_PROGRESS.id, [
    (0, $1sPvo.UFOExperienceState).BLOCKED.id,
    (0, $1sPvo.UFOExperienceState).SUCCEEDED.id,
    (0, $1sPvo.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $1sPvo.UFOExperienceState).FAILED.id,
    (0, $1sPvo.UFOExperienceState).ABORTED.id
]), (0, $gFffs.default)($faa141a145d9a8bc$var$_UFOStateAvailableTra, (0, $1sPvo.UFOExperienceState).BLOCKED.id, [
    (0, $1sPvo.UFOExperienceState).RECOVERED.id,
    (0, $1sPvo.UFOExperienceState).ABORTED.id
]), (0, $gFffs.default)($faa141a145d9a8bc$var$_UFOStateAvailableTra, (0, $1sPvo.UFOExperienceState).RECOVERED.id, [
    (0, $1sPvo.UFOExperienceState).STARTED.id,
    (0, $1sPvo.UFOExperienceState).SUCCEEDED.id,
    (0, $1sPvo.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $1sPvo.UFOExperienceState).FAILED.id,
    (0, $1sPvo.UFOExperienceState).ABORTED.id
]), (0, $gFffs.default)($faa141a145d9a8bc$var$_UFOStateAvailableTra, (0, $1sPvo.UFOExperienceState).SUCCEEDED.id, [
    (0, $1sPvo.UFOExperienceState).STARTED.id
]), (0, $gFffs.default)($faa141a145d9a8bc$var$_UFOStateAvailableTra, (0, $1sPvo.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id, [
    (0, $1sPvo.UFOExperienceState).SUCCEEDED.id,
    (0, $1sPvo.UFOExperienceState).FAILED.id,
    (0, $1sPvo.UFOExperienceState).ABORTED.id
]), (0, $gFffs.default)($faa141a145d9a8bc$var$_UFOStateAvailableTra, (0, $1sPvo.UFOExperienceState).FAILED.id, [
    (0, $1sPvo.UFOExperienceState).STARTED.id
]), (0, $gFffs.default)($faa141a145d9a8bc$var$_UFOStateAvailableTra, (0, $1sPvo.UFOExperienceState).ABORTED.id, [
    (0, $1sPvo.UFOExperienceState).STARTED.id
]), $faa141a145d9a8bc$var$_UFOStateAvailableTra);
var $faa141a145d9a8bc$export$178881f329fdb81f = function canTransition(state1, state2) {
    return $faa141a145d9a8bc$var$UFOStateAvailableTransitions[state1.id] && $faa141a145d9a8bc$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});





parcelRegister("hqgpR", function(module, exports) {
$parcel$export(module.exports, "ActivityClient", function () { return $caf199469e9dacc4$export$157740f5433f3dbe; });

var $fCTsg = parcelRequire("fCTsg");

var $aRrmH = parcelRequire("aRrmH");

var $gFffs = parcelRequire("gFffs");

var $fOIzk = parcelRequire("fOIzk");
var $caf199469e9dacc4$export$157740f5433f3dbe = /*#__PURE__*/ (0, $fCTsg.default)(function ActivityClient(clientVersion, product, headers, baseUrl) {
    (0, $aRrmH.default)(this, ActivityClient);
    (0, $gFffs.default)(this, "product", 'unknown');
    (0, $gFffs.default)(this, "baseUrl", (0, $fOIzk.GRAPHQL_GATEWAY_PATH));
    if (product) this.product = product;
    this.clientVersion = clientVersion;
    this.headers = headers !== null && headers !== void 0 ? headers : {};
    if (baseUrl) this.baseUrl = baseUrl;
});

});
parcelRegister("fOIzk", function(module, exports) {
$parcel$export(module.exports, "GRAPHQL_GATEWAY_PATH", function () { return $b83e18f08c5b81bf$export$851c5df667ca24c8; });
$parcel$export(module.exports, "WORKED_EVENT", function () { return $b83e18f08c5b81bf$export$eb4e9f525aef1cc3; });
var $b83e18f08c5b81bf$export$851c5df667ca24c8 = '/gateway/api/graphql';
var $b83e18f08c5b81bf$export$d245b105c09339d8 = /*#__PURE__*/ function(VIEWED_EVENT) {
    VIEWED_EVENT["VIEWED"] = "viewed";
    return VIEWED_EVENT;
}({});
var $b83e18f08c5b81bf$export$eb4e9f525aef1cc3 = /*#__PURE__*/ function(WORKED_EVENT) {
    WORKED_EVENT["COMMENTED"] = "commented";
    WORKED_EVENT["CREATED"] = "created";
    WORKED_EVENT["EDITED"] = "edited";
    WORKED_EVENT["PUBLISHED"] = "published";
    WORKED_EVENT["UPDATED"] = "updated";
    return WORKED_EVENT;
}({});
var $b83e18f08c5b81bf$export$d02a56686be43f69 = /*#__PURE__*/ function(ActivityObjectType) {
    ActivityObjectType["BLOGPOST"] = "BLOGPOST";
    ActivityObjectType["COMMENT"] = "COMMENT";
    ActivityObjectType["ISSUE"] = "ISSUE";
    ActivityObjectType["PAGE"] = "PAGE";
    ActivityObjectType["PROJECT"] = "PROJECT";
    ActivityObjectType["SITE"] = "SITE";
    ActivityObjectType["SPACE"] = "SPACE";
    ActivityObjectType["TASK"] = "TASK";
    return ActivityObjectType;
}({});

});


parcelRegister("6gfwl", function(module, exports) {
$parcel$export(module.exports, "fetchActivitiesV2", function () { return $48f046cf581a607c$export$750ec7816fdd2f9e; });

var $bHm7w = parcelRequire("bHm7w");

var $hd11L = parcelRequire("hd11L");

var $a9dQv = parcelRequire("a9dQv");

var $8UfbL = parcelRequire("8UfbL");

var $5XQsc = parcelRequire("5XQsc");

var $2reKI = parcelRequire("2reKI");

var $el6fl = parcelRequire("el6fl");
var $48f046cf581a607c$var$_excluded = [
    "limit"
];
var $48f046cf581a607c$var$ACTIVITIES_LIMIT = 50;
// typescript guard for validating the activities connection type
var $48f046cf581a607c$var$isMyActivitiesConnection = function isMyActivitiesConnection(activities) {
    return activities.myActivities !== undefined;
};
var $48f046cf581a607c$var$V2_AVAILABLE_PRODUCTS = [
    'teamCentral',
    'editor',
    'people',
    'jira',
    'townsquare',
    'apOnboarding',
    'worklens',
    'confluence',
    'start'
];
var $48f046cf581a607c$export$750ec7816fdd2f9e = /*#__PURE__*/ function() {
    var _ref2 = (0, $hd11L.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).mark(function _callee(_ref) {
        var _response$data;
        var experience, product, retryMS, _ref$filters, filters, activityQueries, baseUrl, _filters$limit, limit, restFilters, _generateActivityQuer, query, queryFilters, operationProduct, response, workedOn, viewed, all;
        return (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    experience = _ref.experience, product = _ref.product, retryMS = _ref.retryMS, _ref$filters = _ref.filters, filters = _ref$filters === void 0 ? {} : _ref$filters, activityQueries = _ref.activityQueries, baseUrl = _ref.baseUrl;
                    _filters$limit = filters.limit, limit = _filters$limit === void 0 ? $48f046cf581a607c$var$ACTIVITIES_LIMIT : _filters$limit, restFilters = (0, $bHm7w.default)(filters, $48f046cf581a607c$var$_excluded);
                    experience.mark('GeneratedQueryWithFilters_start');
                    _generateActivityQuer = (0, $2reKI.generateActivityQueryWithFilters)(product, restFilters, activityQueries), query = _generateActivityQuer.query, queryFilters = _generateActivityQuer.queryFilters;
                    experience.mark('GeneratedQueryWithFilters_end');
                    // This is to make v2 forwards compatible. Defaulting to start as the product
                    operationProduct = $48f046cf581a607c$var$V2_AVAILABLE_PRODUCTS.includes(product) ? product : 'start';
                    experience.mark('FetchedActivities_start');
                    _context.prev = 7;
                    _context.next = 10;
                    return (0, $5XQsc.postResource)(baseUrl, {
                        operationName: (0, $8UfbL.getOperationName)(operationProduct),
                        query: query,
                        variables: {
                            first: limit,
                            filters: queryFilters
                        }
                    }, retryMS);
                case 10:
                    response = _context.sent;
                    _context.next = 17;
                    break;
                case 13:
                    _context.prev = 13;
                    _context.t0 = _context["catch"](7);
                    if (!(!_context.t0 || _context.t0.statusCode !== 401 && _context.t0.message !== 'The operation was aborted.')) {
                        _context.next = 17;
                        break;
                    }
                    throw _context.t0;
                case 17:
                    experience.mark('FetchedActivities_end');
                    workedOn = [], viewed = [], all = [];
                    if (!(!response || !((_response$data = response.data) !== null && _response$data !== void 0 && _response$data.activities))) {
                        _context.next = 21;
                        break;
                    }
                    return _context.abrupt("return", {
                        all: all,
                        workedOn: workedOn,
                        viewed: viewed
                    });
                case 21:
                    experience.mark('TransformedActivityItems_start');
                    if ($48f046cf581a607c$var$isMyActivitiesConnection(response.data.activities)) {
                        if (response.data.activities.myActivities.workedOn && activityQueries.includes('workedOn')) workedOn = (0, $el6fl.transformActivitiesItems)('workedOn', response.data.activities.myActivities.workedOn);
                        if (response.data.activities.myActivities.viewed && activityQueries.includes('viewed')) viewed = (0, $el6fl.transformActivitiesItems)('viewed', response.data.activities.myActivities.viewed);
                        if (response.data.activities.myActivities.all && activityQueries.includes('all')) all = (0, $el6fl.transformActivitiesItems)('all', response.data.activities.myActivities.all);
                    } else {
                        if (response.data.activities.workedOn && activityQueries.includes('workedOn')) workedOn = (0, $el6fl.transformActivitiesItems)('workedOn', response.data.activities.workedOn);
                        if (response.data.activities.all && activityQueries.includes('all')) all = (0, $el6fl.transformActivitiesItems)('all', response.data.activities.all);
                    }
                    experience.mark('TransformedActivityItems_end');
                    return _context.abrupt("return", {
                        all: all,
                        viewed: viewed,
                        workedOn: workedOn
                    });
                case 25:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                7,
                13
            ]
        ]);
    }));
    return function fetchActivitiesV2(_x) {
        return _ref2.apply(this, arguments);
    };
}();

});
parcelRegister("bHm7w", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8844de8125959d9b$export$2e2bcd8739ae039; });

var $9rsMg = parcelRequire("9rsMg");
function $8844de8125959d9b$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $9rsMg.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("9rsMg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6dfcf54b14ca11fc$export$2e2bcd8739ae039; });
function $6dfcf54b14ca11fc$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("8UfbL", function(module, exports) {
$parcel$export(module.exports, "getOperationName", function () { return $67bf55daaab91040$export$41bca9dc6871dd4e; });

var $lXgpb = parcelRequire("lXgpb");
var $67bf55daaab91040$export$ad1e21d37f385bcb = function formatProductForOperation(product) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($lXgpb)))(product);
};
var $67bf55daaab91040$export$41bca9dc6871dd4e = function getOperationName(product) {
    return "".concat($67bf55daaab91040$export$ad1e21d37f385bcb(product), "_activity_recentWorkClient");
};

});

parcelRegister("5XQsc", function(module, exports) {
$parcel$export(module.exports, "postResource", function () { return $457b26b1e243507d$export$2ff3e1f219ccfad6; });

var $gFffs = parcelRequire("gFffs");

var $hd11L = parcelRequire("hd11L");

var $a9dQv = parcelRequire("a9dQv");
parcelRequire("gUHXN");
var $9Zkb8 = parcelRequire("9Zkb8");
var $gUHXN = parcelRequire("gUHXN");

var $gcB9L = parcelRequire("gcB9L");

var $6tfcl = parcelRequire("6tfcl");
function $457b26b1e243507d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $457b26b1e243507d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $457b26b1e243507d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gFffs.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $457b26b1e243507d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $457b26b1e243507d$var$fetchResource = /*#__PURE__*/ function() {
    var _ref = (0, $hd11L.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).mark(function _callee(path, method) {
        var options, url, response, statusCode, text, httpError, _args = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
                    url = (0, $gcB9L.getFullUrl)(path);
                    _context.next = 4;
                    return fetch(url, $457b26b1e243507d$var$_objectSpread({
                        credentials: 'include',
                        method: method
                    }, options)).catch(function(error) {
                        throw new (0, $9Zkb8.default)({
                            error: error,
                            path: path,
                            method: method
                        });
                    });
                case 4:
                    response = _context.sent;
                    statusCode = response.status;
                    if (response.ok) {
                        _context.next = 15;
                        break;
                    }
                    statusCode;
                    _context.t0 = $457b26b1e243507d$var$scrubTimestampFromErrorBody;
                    _context.next = 11;
                    return response.text();
                case 11:
                    _context.t1 = _context.sent;
                    text = (0, _context.t0)(_context.t1);
                    httpError = new (0, $6tfcl.default)({
                        message: text,
                        method: method,
                        path: path,
                        statusCode: statusCode,
                        xRequestId: response.headers.get('x-request-id'),
                        headers: response.headers
                    });
                    throw httpError;
                case 15:
                    return _context.abrupt("return", response);
                case 16:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function fetchResource(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
var $457b26b1e243507d$var$makeJsonRquest = /*#__PURE__*/ function() {
    var _ref2 = (0, $hd11L.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).mark(function _callee2(path, method) {
        var additionalFetchOptions, response, text, _args2 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    additionalFetchOptions = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
                    _context2.next = 3;
                    return $457b26b1e243507d$var$fetchResource(path, method, additionalFetchOptions);
                case 3:
                    response = _context2.sent;
                    _context2.next = 6;
                    return response.text();
                case 6:
                    text = _context2.sent;
                    return _context2.abrupt("return", text ? JSON.parse(text) : {});
                case 8:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function makeJsonRquest(_x3, _x4) {
        return _ref2.apply(this, arguments);
    };
}();
var $457b26b1e243507d$export$2ff3e1f219ccfad6 = /*#__PURE__*/ function() {
    var _ref3 = (0, $hd11L.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).mark(function _callee3(path, data, retryMS, extraHeaders) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    return _context3.abrupt("return", (0, $gUHXN.retryOnException)(function() {
                        return $457b26b1e243507d$var$makeJsonRquest(path, 'POST', {
                            body: JSON.stringify(data),
                            headers: $457b26b1e243507d$var$_objectSpread({
                                'content-type': 'application/json'
                            }, extraHeaders)
                        });
                    }, {
                        intervalsMS: retryMS !== null && retryMS !== void 0 ? retryMS : []
                    }));
                case 1:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function postResource(_x5, _x6, _x7, _x8) {
        return _ref3.apply(this, arguments);
    };
}();
// to dedup sentry, scrub non-unique 'timestamp' field from the error body
function $457b26b1e243507d$var$scrubTimestampFromErrorBody(text) {
    var json;
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp;
    return JSON.stringify(json);
}

});
parcelRegister("gUHXN", function(module, exports) {
$parcel$export(module.exports, "retryOnException", function () { return $c503fa8818b1581d$export$1d94629c94e7a17f; });
$parcel$export(module.exports, "FailedFetchError", function () { return (parcelRequire("9Zkb8")).default; });

var $ivoqu = parcelRequire("ivoqu");

var $hd11L = parcelRequire("hd11L");

var $a9dQv = parcelRequire("a9dQv");

var $9WfMr = parcelRequire("9WfMr");

var $03Geo = parcelRequire("03Geo");

var $9Zkb8 = parcelRequire("9Zkb8");
var $c503fa8818b1581d$export$5c069c93d2b7493f = function wait(ms) {
    return new Promise(function(resolve) {
        setTimeout(resolve, ms);
    });
};
var $c503fa8818b1581d$var$NO_CALLS_ERROR = 'No calls made';
var $c503fa8818b1581d$export$1d94629c94e7a17f = /*#__PURE__*/ function() {
    var _ref2 = (0, $hd11L.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).mark(function _callee(invokeOperation, _ref) {
        var _ref$intervalsMS, intervalsMS, _ref$retryOn, retryOn, captureException, onRetry, intervals, nextMSInterval, error;
        return (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _ref$intervalsMS = _ref.intervalsMS, intervalsMS = _ref$intervalsMS === void 0 ? (0, $03Geo.NO_RETRIES) : _ref$intervalsMS, _ref$retryOn = _ref.retryOn, retryOn = _ref$retryOn === void 0 ? [
                        (0, $9Zkb8.default)
                    ] : _ref$retryOn, captureException = _ref.captureException, onRetry = _ref.onRetry;
                    intervals = (0, $ivoqu.default)(intervalsMS);
                    nextMSInterval = 0;
                    error = new Error($c503fa8818b1581d$var$NO_CALLS_ERROR);
                case 4:
                    if (!(nextMSInterval !== undefined)) {
                        _context.next = 22;
                        break;
                    }
                    _context.prev = 5;
                    if (!(nextMSInterval > 0)) {
                        _context.next = 9;
                        break;
                    }
                    _context.next = 9;
                    return $c503fa8818b1581d$export$5c069c93d2b7493f(nextMSInterval);
                case 9:
                    if (onRetry && error.message !== $c503fa8818b1581d$var$NO_CALLS_ERROR) onRetry(error);
                    _context.next = 12;
                    return invokeOperation();
                case 12:
                    return _context.abrupt("return", _context.sent);
                case 15:
                    _context.prev = 15;
                    _context.t0 = _context["catch"](5);
                    error = (0, $9WfMr.default)(_context.t0);
                    if (captureException) captureException(error);
                    // Retry ONLY when the error is an instance of one of the provided `retryOn` errors, or passes the `retryOn` test.
                    // You need to ensure you are throwing one of the `retryOn` errors if that is the method you are using.
                    if (typeof retryOn === 'function' ? retryOn(error) : retryOn.some(function(err) {
                        return error instanceof err;
                    })) nextMSInterval = intervals.shift();
                    else nextMSInterval = undefined;
                case 20:
                    _context.next = 4;
                    break;
                case 22:
                    throw error;
                case 23:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                5,
                15
            ]
        ]);
    }));
    return function retryOnException(_x, _x2) {
        return _ref2.apply(this, arguments);
    };
}();

});
parcelRegister("9WfMr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $73c5c579c2f24549$export$2e2bcd8739ae039; });

var $bYF3k = parcelRequire("bYF3k");
var $73c5c579c2f24549$var$convertToError = function convertToError(e) {
    var error;
    if (e instanceof Error) error = e;
    else if (typeof e === 'string') error = new Error(e);
    else if ((0, $bYF3k.default)(e) === 'object') try {
        error = new Error('Object error instance thrown for operation: ' + JSON.stringify(e));
    } catch (jsonError) {
        error = new Error('Object serialisation error thrown during operation: ' + String(e));
    }
    else error = new Error('No error instance thrown for operation: ' + String(e));
    return error;
};
var $73c5c579c2f24549$export$2e2bcd8739ae039 = $73c5c579c2f24549$var$convertToError;

});

parcelRegister("03Geo", function(module, exports) {
$parcel$export(module.exports, "NO_RETRIES", function () { return $00b10a2bec117208$export$a0a1c8f90becc136; });
var $00b10a2bec117208$export$a0a1c8f90becc136 = [];
var $00b10a2bec117208$export$972171517b12aa4 = [
    0,
    0
];
var $00b10a2bec117208$export$746d2203ed8cdc40 = [
    0,
    50,
    100
];
var $00b10a2bec117208$export$f6858378b665f957 = [
    100,
    500,
    1000
];

});

parcelRegister("9Zkb8", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7459769eef8fe667$export$2e2bcd8739ae039; });

var $fCTsg = parcelRequire("fCTsg");

var $aRrmH = parcelRequire("aRrmH");

var $6VWyZ = parcelRequire("6VWyZ");

var $bGqVi = parcelRequire("bGqVi");

var $5pRqT = parcelRequire("5pRqT");

var $7DNMr = parcelRequire("7DNMr");
function $7459769eef8fe667$var$_callSuper(t, o, e) {
    return o = (0, $bGqVi.default)(o), (0, $6VWyZ.default)(t, $7459769eef8fe667$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $bGqVi.default)(t).constructor) : o.apply(t, e));
}
function $7459769eef8fe667$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7459769eef8fe667$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $7459769eef8fe667$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    function FailedFetchError(_ref) {
        var _this;
        var error = _ref.error, path = _ref.path, method = _ref.method;
        (0, $aRrmH.default)(this, FailedFetchError);
        _this = $7459769eef8fe667$var$_callSuper(this, FailedFetchError);
        _this.name = 'FailedFetchError';
        _this.message = error.message || 'Unknown fetch error';
        _this.stack = error.stack;
        _this.originalName = error.name;
        _this.method = method;
        var p = path.split('?')[0];
        _this.path = /^[/-a-z]+$/i.test(p) ? p : '';
        return _this;
    }
    (0, $5pRqT.default)(FailedFetchError, _Error);
    return (0, $fCTsg.default)(FailedFetchError);
}(/*#__PURE__*/ (0, $7DNMr.default)(Error));

});


parcelRegister("gcB9L", function(module, exports) {
$parcel$export(module.exports, "getFullUrl", function () { return $bcba96d659f25196$export$2414511207262909; });
var $bcba96d659f25196$var$urlRegex = new RegExp(/^https?:\/\//);
function $bcba96d659f25196$export$2414511207262909(path) {
    var hostConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        host: window.location.hostname,
        port: window.location.port
    };
    // always return a just the URL if one is provided
    if ($bcba96d659f25196$var$urlRegex.test(path)) return path;
    return hostConfig.host === 'localhost' ? "http://".concat(hostConfig.host, ":").concat(hostConfig.port).concat(path) : path;
}

});


parcelRegister("2reKI", function(module, exports) {
$parcel$export(module.exports, "generateActivityQueryWithFilters", function () { return $1c698be7a7023701$export$855cd08371c65b8c; });

var $8UfbL = parcelRequire("8UfbL");

var $3MW3V = parcelRequire("3MW3V");
var $1c698be7a7023701$var$ACTIVITIES = "\n  nodes {\n    id\n    timestamp\n    object {\n      id\n      name\n      cloudId\n      localResourceId\n      product\n      type\n      url\n      iconUrl\n      containers {\n        name\n      }\n      contributors {\n        profile {\n          accountId\n          name\n          picture\n        }\n      }\n      events {\n        eventType\n      }\n      extension {\n        ... on ActivitiesJiraIssue {\n          issueKey\n        }\n      }\n    }\n  }\n";
var $1c698be7a7023701$var$WORKED_ON_QUERY = "\n   workedOn(first: $first, filters: $filters) {\n     ".concat($1c698be7a7023701$var$ACTIVITIES, "\n   }\n");
var $1c698be7a7023701$var$VIEWED__QUERY = "\n   viewed(first: $first, filters: $filters) {\n     ".concat($1c698be7a7023701$var$ACTIVITIES, "\n   }\n");
var $1c698be7a7023701$var$ALL__QUERY = "\n    all(first: $first, filters: $filters) {\n      ".concat($1c698be7a7023701$var$ACTIVITIES, "\n    }\n");
var $1c698be7a7023701$var$activityQueryMap = new Map([
    [
        'workedOn',
        $1c698be7a7023701$var$WORKED_ON_QUERY
    ],
    [
        'viewed',
        $1c698be7a7023701$var$VIEWED__QUERY
    ],
    [
        'all',
        $1c698be7a7023701$var$ALL__QUERY
    ]
]);
var $1c698be7a7023701$var$getMyActivitiesQuery = function getMyActivitiesQuery(queries) {
    return "\n      myActivities {\n        ".concat(queries.join('\n'), "\n      }\n");
};
var $1c698be7a7023701$var$getActivitiesQuery = function getActivitiesQuery(product, content) {
    return "\n    query ".concat((0, $8UfbL.getOperationName)(product), "($first: Int, $filters: [ActivitiesFilter!]) {\n      activities {\n        ").concat(content, "\n      }\n    }\n");
};
var $1c698be7a7023701$export$855cd08371c65b8c = function generateActivityQueryWithFilters(product, filters, activityQueries) {
    /**
   * If we are filtering by `accountIds` then we can't use the `myActivity` query.
   */ if (Array.isArray(filters.actors)) {
        // you can't view `viewed` events for other accounts
        var filteredAccountQueries = activityQueries.filter(function(query) {
            return query !== 'viewed';
        });
        return {
            query: $1c698be7a7023701$var$getActivitiesQuery(product, filteredAccountQueries.map(function(query) {
                return $1c698be7a7023701$var$activityQueryMap.get(query);
            }).join('\n')),
            queryFilters: (0, $3MW3V.ACTIVITY_FILTER_COLLECTION).v2.get('activities')(filters)
        };
    } else return {
        query: $1c698be7a7023701$var$getActivitiesQuery(product, $1c698be7a7023701$var$getMyActivitiesQuery(activityQueries.map(function(query) {
            return $1c698be7a7023701$var$activityQueryMap.get(query);
        }))),
        queryFilters: (0, $3MW3V.ACTIVITY_FILTER_COLLECTION).v2.get('myActivity')(filters)
    };
};

});
parcelRegister("3MW3V", function(module, exports) {
$parcel$export(module.exports, "ACTIVITY_FILTER_COLLECTION", function () { return $2c22e4c5ab4a7bf3$export$5201d39848130041; });

var $goASW = parcelRequire("goASW");

var $bF3YF = parcelRequire("bF3YF");
var $2c22e4c5ab4a7bf3$export$5201d39848130041 = {
    v2: (0, $goASW.ACTIVITY_FILTER_V2_MAP),
    v3: (0, $bF3YF.ACTIVITY_FILTER_V3_MAP)
};

});
parcelRegister("goASW", function(module, exports) {
$parcel$export(module.exports, "ACTIVITY_FILTER_V2_MAP", function () { return $befb7fdc5ea8453d$export$1dca7bc1ec360897; });

var $5JJwZ = parcelRequire("5JJwZ");

var $9ZSCC = parcelRequire("9ZSCC");
var $befb7fdc5ea8453d$export$1dca7bc1ec360897 = new Map([
    [
        'myActivity',
        (0, $9ZSCC.default)
    ],
    [
        'activities',
        (0, $5JJwZ.default)
    ]
]);

});
parcelRegister("5JJwZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $42d47942883c0d30$export$2e2bcd8739ae039; });

var $bHm7w = parcelRequire("bHm7w");

var $eqADc = parcelRequire("eqADc");
var $42d47942883c0d30$var$_excluded = [
    "limit"
];
/**
 * This is the query builder for the v2 - activities API
 *
 * @param filters
 */ var $42d47942883c0d30$var$generateV2ActivitiesFilters = function generateV2ActivitiesFilters() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var limit = filters.limit, restFilters = (0, $bHm7w.default)(filters, $42d47942883c0d30$var$_excluded);
    return (0, $eqADc.generateActivityFiltersV2)(restFilters);
};
var $42d47942883c0d30$export$2e2bcd8739ae039 = $42d47942883c0d30$var$generateV2ActivitiesFilters;

});
parcelRegister("eqADc", function(module, exports) {
$parcel$export(module.exports, "generateActivityFiltersV2", function () { return $a80fe8968b7802f9$export$ebef9c1f1e15c057; });

var $gFffs = parcelRequire("gFffs");

var $aYF7h = parcelRequire("aYF7h");
// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
var $a80fe8968b7802f9$var$FILTERS_TO_TRANSFORM__UPPERCASE = [
    'products',
    'eventTypes',
    'objectTypes'
];
var $a80fe8968b7802f9$var$KEYS_TO_TRANSFROM = new Map([
    [
        'actors',
        'accountIds'
    ]
]);
var $a80fe8968b7802f9$export$ebef9c1f1e15c057 = function generateActivityFiltersV2() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (0, $aYF7h.generateActivityFilters)(filters, function(originalkey, originalFilter) {
        var filter = Array.isArray(originalFilter) && $a80fe8968b7802f9$var$FILTERS_TO_TRANSFORM__UPPERCASE.includes(originalkey) ? originalFilter.map(function(f) {
            return f.toUpperCase();
        }) : originalFilter;
        var key = $a80fe8968b7802f9$var$KEYS_TO_TRANSFROM.has(originalkey) ? $a80fe8968b7802f9$var$KEYS_TO_TRANSFROM.get(originalkey) : originalkey;
        return (0, $gFffs.default)({}, key, filter);
    });
};

});
parcelRegister("aYF7h", function(module, exports) {
$parcel$export(module.exports, "generateActivityFilters", function () { return $7fdf66dcd3826252$export$23c75313f46dd54e; });

var $gFffs = parcelRequire("gFffs");

var $iy2hK = parcelRequire("iy2hK");
function $7fdf66dcd3826252$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7fdf66dcd3826252$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7fdf66dcd3826252$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gFffs.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7fdf66dcd3826252$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7fdf66dcd3826252$export$23c75313f46dd54e = function generateActivityFilters() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var transform = arguments.length > 1 ? arguments[1] : undefined;
    var rootLevelFilters = arguments.length > 2 ? arguments[2] : undefined;
    return Object.entries(filters).reduce(function(acc, _ref) {
        var _ref2 = (0, $iy2hK.default)(_ref, 2), key = _ref2[0], filter = _ref2[1];
        var entry = transform ? transform(key, filter) : (0, $gFffs.default)({}, key, filter);
        return rootLevelFilters !== null && rootLevelFilters !== void 0 && rootLevelFilters.includes(key) ? $7fdf66dcd3826252$var$_objectSpread($7fdf66dcd3826252$var$_objectSpread({}, acc), entry) : $7fdf66dcd3826252$var$_objectSpread($7fdf66dcd3826252$var$_objectSpread({}, acc), {}, {
            arguments: $7fdf66dcd3826252$var$_objectSpread($7fdf66dcd3826252$var$_objectSpread({}, acc.arguments), entry)
        });
    }, {
        type: 'AND',
        arguments: {}
    });
};

});
parcelRegister("iy2hK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d80d2cc11065e834$export$2e2bcd8739ae039; });

var $a4tUu = parcelRequire("a4tUu");

var $30sm2 = parcelRequire("30sm2");

var $k05Cj = parcelRequire("k05Cj");

var $rByJa = parcelRequire("rByJa");
function $d80d2cc11065e834$export$2e2bcd8739ae039(r, e) {
    return (0, $a4tUu.default)(r) || (0, $30sm2.default)(r, e) || (0, $k05Cj.default)(r, e) || (0, $rByJa.default)();
}

});
parcelRegister("a4tUu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $75517aa84c39e439$export$2e2bcd8739ae039; });
function $75517aa84c39e439$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("30sm2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $23075dcbdb6a7945$export$2e2bcd8739ae039; });
function $23075dcbdb6a7945$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("rByJa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $052fa83097a3a225$export$2e2bcd8739ae039; });
function $052fa83097a3a225$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});





parcelRegister("9ZSCC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $74742e543df2a0f8$export$2e2bcd8739ae039; });

var $bHm7w = parcelRequire("bHm7w");

var $eqADc = parcelRequire("eqADc");
var $74742e543df2a0f8$var$_excluded = [
    "limit",
    "actors"
];
/**
 * This is the query builder for the v2 - myActivity API
 *
 * @param filters
 */ var $74742e543df2a0f8$var$generateV2MyActivityFilters = function generateV2MyActivityFilters() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var limit = filters.limit, actors = filters.actors, restFilters = (0, $bHm7w.default)(filters, $74742e543df2a0f8$var$_excluded);
    return (0, $eqADc.generateActivityFiltersV2)(restFilters);
};
var $74742e543df2a0f8$export$2e2bcd8739ae039 = $74742e543df2a0f8$var$generateV2MyActivityFilters;

});


parcelRegister("bF3YF", function(module, exports) {
$parcel$export(module.exports, "ACTIVITY_FILTER_V3_MAP", function () { return $87d69be94977d3ad$export$9a1782843b6e99d2; });

var $9yTBl = parcelRequire("9yTBl");

var $jDqtZ = parcelRequire("jDqtZ");
var $87d69be94977d3ad$export$9a1782843b6e99d2 = new Map([
    [
        'myActivity',
        (0, $jDqtZ.default)
    ],
    [
        'activities',
        (0, $9yTBl.default)
    ]
]);

});
parcelRegister("9yTBl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6f626b4c3f5558ac$export$2e2bcd8739ae039; });

var $bHm7w = parcelRequire("bHm7w");

var $5RIfX = parcelRequire("5RIfX");
var $6f626b4c3f5558ac$var$_excluded = [
    "limit"
];
/**
 * This is the query builder for the v3 - activities API
 *
 * @param filters
 */ var $6f626b4c3f5558ac$var$generateV3ActivityFilters = function generateV3ActivityFilters() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var limit = filters.limit, restFilters = (0, $bHm7w.default)(filters, $6f626b4c3f5558ac$var$_excluded);
    return (0, $5RIfX.generateActivityFiltersV3)(restFilters);
};
var $6f626b4c3f5558ac$export$2e2bcd8739ae039 = $6f626b4c3f5558ac$var$generateV3ActivityFilters;

});
parcelRegister("5RIfX", function(module, exports) {
$parcel$export(module.exports, "generateActivityFiltersV3", function () { return $44543b60d5046812$export$e73fe7ded3fe2664; });

var $gFffs = parcelRequire("gFffs");

var $aYF7h = parcelRequire("aYF7h");
// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
var $44543b60d5046812$var$FILTERS_TO_TRANSFORM__LOWERCASE = [
    'products',
    'eventTypes',
    'objectTypes'
];
var $44543b60d5046812$var$ROOT_LEVEL_FILTERS = [
    'actors',
    'rootContainerIds'
];
var $44543b60d5046812$export$e73fe7ded3fe2664 = function generateActivityFiltersV3() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (0, $aYF7h.generateActivityFilters)(filters, function(key, filter) {
        return Array.isArray(filter) && $44543b60d5046812$var$FILTERS_TO_TRANSFORM__LOWERCASE.includes(key) ? (0, $gFffs.default)({}, key, filter.map(function(f) {
            return f.toLowerCase();
        })) : (0, $gFffs.default)({}, key, filter);
    }, $44543b60d5046812$var$ROOT_LEVEL_FILTERS);
};

});


parcelRegister("jDqtZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e4b633bb10ef7390$export$2e2bcd8739ae039; });

var $bHm7w = parcelRequire("bHm7w");

var $5RIfX = parcelRequire("5RIfX");
var $e4b633bb10ef7390$var$_excluded = [
    "limit",
    "actors"
];
/**
 * This is the query builder for the v3 - myActivity API
 *
 * @param filters
 */ var $e4b633bb10ef7390$var$generateV3MyActivityFilters = function generateV3MyActivityFilters() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var limit = filters.limit, actors = filters.actors, restFilters = (0, $bHm7w.default)(filters, $e4b633bb10ef7390$var$_excluded);
    return (0, $5RIfX.generateActivityFiltersV3)(restFilters);
};
var $e4b633bb10ef7390$export$2e2bcd8739ae039 = $e4b633bb10ef7390$var$generateV3MyActivityFilters;

});




parcelRegister("el6fl", function(module, exports) {
$parcel$export(module.exports, "transformActivitiesItems", function () { return $a707df465a5701f5$export$306a8b649360ca6f; });
var $a707df465a5701f5$var$SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
function $a707df465a5701f5$export$306a8b649360ca6f(query) {
    var activities = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!activities || !activities.nodes) return [];
    return activities.nodes.map(function(item) {
        var object = item.object, timestamp = item.timestamp;
        var cloudId = object.cloudId, events = object.events, extension = object.extension, iconUrl = object.iconUrl, id = object.id, localResourceId = object.localResourceId, name = object.name, product = object.product, url = object.url, type = object.type;
        // V2 returns eventType captilised, V3 returns lowercase
        var eventType = events[0].eventType.toLowerCase();
        var issueKey = extension && extension.issueKey;
        var containers = [];
        if (issueKey) containers.push({
            name: issueKey
        });
        if (Array.isArray(object.containers)) containers = containers.concat(object.containers);
        containers = containers.filter(function(container) {
            return !!container.name;
        });
        return {
            query: query,
            containers: containers,
            contributors: (object.contributors || []).reduce(function(contributors, contributor) {
                if (contributor.profile) {
                    var _contributor$profile = contributor.profile, accountId = _contributor$profile.accountId, picture = _contributor$profile.picture;
                    contributors.push({
                        accountId: accountId,
                        name: contributor.profile.name,
                        picture: picture
                    });
                }
                return contributors;
            }, []),
            eventType: eventType,
            object: {
                rootContainerIdentifier: {
                    id: cloudId,
                    type: 'SITE',
                    ari: "".concat($a707df465a5701f5$var$SITE_ARI_PREFIX).concat(cloudId)
                },
                deduplicateId: id,
                icon: {
                    type: 'URL',
                    value: iconUrl
                },
                id: id,
                localResourceId: localResourceId,
                name: name,
                product: product,
                subProduct: null,
                type: type,
                url: url
            },
            timestamp: timestamp
        };
    });
}

});



parcelRegister("4zPwD", function(module, exports) {
$parcel$export(module.exports, "ActivityClientV3", function () { return $35526630329575d9$export$3c3c237c92ca1fb9; });

var $hd11L = parcelRequire("hd11L");

var $fCTsg = parcelRequire("fCTsg");

var $aRrmH = parcelRequire("aRrmH");

var $6VWyZ = parcelRequire("6VWyZ");

var $bGqVi = parcelRequire("bGqVi");

var $5pRqT = parcelRequire("5pRqT");

var $gFffs = parcelRequire("gFffs");

var $a9dQv = parcelRequire("a9dQv");

var $gUHXN = parcelRequire("gUHXN");

var $fOIzk = parcelRequire("fOIzk");

var $bmweo = parcelRequire("bmweo");

var $f4XZt = parcelRequire("f4XZt");

var $5XQsc = parcelRequire("5XQsc");

var $9Cd3n = parcelRequire("9Cd3n");

var $8c5iM = parcelRequire("8c5iM");

var $3MjIr = parcelRequire("3MjIr");

var $cOEz4 = parcelRequire("cOEz4");

var $lrhDf = parcelRequire("lrhDf");

var $kttmz = parcelRequire("kttmz");

var $hqgpR = parcelRequire("hqgpR");

var $cCmIC = parcelRequire("cCmIC");

var $gz827 = parcelRequire("gz827");

var $c53UJ = parcelRequire("c53UJ");
function $35526630329575d9$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $35526630329575d9$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $35526630329575d9$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $35526630329575d9$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $35526630329575d9$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $35526630329575d9$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $35526630329575d9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $35526630329575d9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $35526630329575d9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gFffs.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $35526630329575d9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $35526630329575d9$var$_callSuper(t, o, e) {
    return o = (0, $bGqVi.default)(o), (0, $6VWyZ.default)(t, $35526630329575d9$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $bGqVi.default)(t).constructor) : o.apply(t, e));
}
function $35526630329575d9$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($35526630329575d9$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $35526630329575d9$var$CONFLUENCE_COMMENT_TYPENAMES = [
    'ConfluenceComment',
    'ConfluenceFooterComment',
    'ConfluenceInlineComment'
];
var $35526630329575d9$var$IGNORED_HTTP_ERRORS = new Map([
    // ignore all 401 errors
    [
        401,
        [
            /.*/
        ]
    ],
    [
        403,
        [
            /Invalid CORS request/
        ]
    ]
]);
var $35526630329575d9$var$IGNORED_ERROR_MESSAGES = [
    'The operation was aborted.'
];
var $35526630329575d9$var$DEFAULT_TAGS = {
    source: (0, $bmweo.packageName),
    sourcePackageVersion: (0, $bmweo.packageVersion)
};
var $35526630329575d9$export$3c3c237c92ca1fb9 = /*#__PURE__*/ function(_ActivityClient) {
    function ActivityClientV3(_product, baseUrl, logger, configFetch) {
        var _this;
        (0, $aRrmH.default)(this, ActivityClientV3);
        _this = $35526630329575d9$var$_callSuper(this, ActivityClientV3, [
            'v3',
            _product,
            {
                'X-ExperimentalApi': 'ActivityV3Api'
            },
            baseUrl
        ]);
        (0, $gFffs.default)(_this, "setProduct", function(product) {
            _this.product = product;
        });
        (0, $gFffs.default)(_this, "captureException", function(error, tags) {
            if (_this.clientHandlers) _this.clientHandlers.captureException(error, $35526630329575d9$var$_objectSpread($35526630329575d9$var$_objectSpread({}, $35526630329575d9$var$DEFAULT_TAGS), tags));
        });
        (0, $gFffs.default)(_this, "captureWarning", function(message, tags) {
            if (_this.clientHandlers) _this.clientHandlers.captureWarning(message, $35526630329575d9$var$_objectSpread($35526630329575d9$var$_objectSpread({}, $35526630329575d9$var$DEFAULT_TAGS), tags));
        });
        (0, $gFffs.default)(_this, "fetchHydratorConfig", /*#__PURE__*/ (0, $hd11L.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).mark(function _callee() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.next = 2;
                        return _this.hydratorConfigClient.fetchConfig();
                    case 2:
                        return _context.abrupt("return", _context.sent);
                    case 3:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        })));
        (0, $gFffs.default)(_this, "handleGraphQLErrors", function(errors) {
            var invalidFragments = [];
            if (Array.isArray(errors)) {
                var _iterator = $35526630329575d9$var$_createForOfIteratorHelper(errors), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var err = _step.value;
                        _this.captureException(new (0, $8c5iM.GraphQLJSError)(err));
                        var invalidFragment = (0, $cCmIC.default)(err);
                        if (invalidFragment) invalidFragments.push(invalidFragment);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return invalidFragments;
            }
            return [];
        });
        (0, $gFffs.default)(_this, "fetchActivitiesV3", /*#__PURE__*/ function() {
            var _ref2 = (0, $hd11L.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).mark(function _callee3(experience, retryMS, filters, activityQueries) {
                var _response$data, _activityRoot, _response$data$activi, _activityRoot2;
                var deduplicateActivities, _yield$_this$fetchHyd, fragments, hydrators, response, _IGNORED_HTTP_ERRORS$, workedOn, viewed, all, activities, _args3 = arguments;
                return (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).wrap(function _callee3$(_context3) {
                    while(true)switch(_context3.prev = _context3.next){
                        case 0:
                            deduplicateActivities = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : true;
                            _context3.next = 3;
                            return _this.fetchHydratorConfig();
                        case 3:
                            _yield$_this$fetchHyd = _context3.sent;
                            fragments = _yield$_this$fetchHyd.fragments;
                            hydrators = _yield$_this$fetchHyd.hydrators;
                            experience.mark('GeneratedQueryWithFilters_start');
                            _context3.prev = 7;
                            _context3.next = 10;
                            return (0, $gUHXN.retryOnException)(/*#__PURE__*/ (0, $hd11L.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).mark(function _callee2() {
                                var request, res, invalidFragments;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).wrap(function _callee2$(_context2) {
                                    while(true)switch(_context2.prev = _context2.next){
                                        case 0:
                                            request = (0, $gz827.generateGraphQLRequest)(_this.product, filters, activityQueries, fragments);
                                            experience.mark('GeneratedQueryWithFilters_end');
                                            experience.mark('FetchedActivities_start');
                                            experience.addMetadata({
                                                filters: (0, $c53UJ.filtersToMetadata)(filters)
                                            });
                                            _context2.next = 6;
                                            return (0, $5XQsc.postResource)(_this.baseUrl, request, retryMS, $35526630329575d9$var$_objectSpread({}, _this.headers));
                                        case 6:
                                            res = _context2.sent;
                                            experience.mark('FetchedActivities_end');
                                            invalidFragments = _this.handleGraphQLErrors(res === null || res === void 0 ? void 0 : res.errors);
                                            if (!(invalidFragments.length > 0)) {
                                                _context2.next = 12;
                                                break;
                                            }
                                            fragments = (0, $c53UJ.filterInvalidFragments)(invalidFragments, fragments);
                                            throw new (0, $9Cd3n.GraphQLFragmentError)("Missing fragments: [".concat(invalidFragments.toString(), "]"));
                                        case 12:
                                            return _context2.abrupt("return", res);
                                        case 13:
                                        case "end":
                                            return _context2.stop();
                                    }
                                }, _callee2);
                            })), {
                                intervalsMS: [
                                    0,
                                    0,
                                    0
                                ],
                                retryOn: function retryOn(err) {
                                    return [
                                        (0, $9Cd3n.GraphQLFragmentError)
                                    ].some(function(retriableErr) {
                                        return err instanceof retriableErr;
                                    });
                                },
                                captureException: _this.captureException
                            });
                        case 10:
                            response = _context3.sent;
                            _context3.next = 17;
                            break;
                        case 13:
                            _context3.prev = 13;
                            _context3.t0 = _context3["catch"](7);
                            if (!(!_context3.t0 || !((_IGNORED_HTTP_ERRORS$ = $35526630329575d9$var$IGNORED_HTTP_ERRORS.get(_context3.t0.statusCode)) !== null && _IGNORED_HTTP_ERRORS$ !== void 0 && _IGNORED_HTTP_ERRORS$.some(function(regExp) {
                                return regExp.test(_context3.t0.message);
                            })) && !$35526630329575d9$var$IGNORED_ERROR_MESSAGES.includes(_context3.t0.message))) {
                                _context3.next = 17;
                                break;
                            }
                            throw _context3.t0;
                        case 17:
                            if (!(0, $c53UJ.isEmptyActivitiesWithErrorsResponse)(response)) {
                                _context3.next = 19;
                                break;
                            }
                            throw new (0, $3MjIr.GraphQLNoResultsError)(response.errors);
                        case 19:
                            if (!(!response || !((_response$data = response.data) !== null && _response$data !== void 0 && _response$data.activity))) {
                                _context3.next = 21;
                                break;
                            }
                            return _context3.abrupt("return", {
                                workedOn: [],
                                viewed: [],
                                all: []
                            });
                        case 21:
                            experience.mark('TransformedActivityItems_start');
                            workedOn = $35526630329575d9$var$transformActivityItem('workedOn', ((_activityRoot = (0, $c53UJ.activityRoot)(response.data.activity)) === null || _activityRoot === void 0 || (_activityRoot = _activityRoot.workedOn) === null || _activityRoot === void 0 ? void 0 : _activityRoot.edges) || [], hydrators, _this.captureException); // We don't need the activity root function here as viewed only exists on myActivity
                            viewed = $35526630329575d9$var$transformActivityItem('viewed', ((_response$data$activi = response.data.activity) === null || _response$data$activi === void 0 || (_response$data$activi = _response$data$activi.myActivity) === null || _response$data$activi === void 0 || (_response$data$activi = _response$data$activi.viewed) === null || _response$data$activi === void 0 ? void 0 : _response$data$activi.edges) || [], hydrators, _this.captureException);
                            all = $35526630329575d9$var$transformActivityItem('all', ((_activityRoot2 = (0, $c53UJ.activityRoot)(response.data.activity)) === null || _activityRoot2 === void 0 || (_activityRoot2 = _activityRoot2.all) === null || _activityRoot2 === void 0 ? void 0 : _activityRoot2.edges) || [], hydrators, _this.captureException);
                            experience.mark('TransformedActivityItems_end');
                            activities = {
                                viewed: viewed,
                                workedOn: workedOn,
                                all: all
                            };
                            return _context3.abrupt("return", deduplicateActivities ? (0, $c53UJ.rollupActivitiesData)(activities) : activities);
                        case 28:
                        case "end":
                            return _context3.stop();
                    }
                }, _callee3, null, [
                    [
                        7,
                        13
                    ]
                ]);
            }));
            return function(_x, _x2, _x3, _x4) {
                return _ref2.apply(this, arguments);
            };
        }());
        (0, $gFffs.default)(_this, "fetchActivities", /*#__PURE__*/ function() {
            var _ref4 = (0, $hd11L.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).mark(function _callee4(retryMS, filters, activityQueries) {
                var deduplicateActivities, _args4 = arguments;
                return (0, (/*@__PURE__*/$parcel$interopDefault($a9dQv))).wrap(function _callee4$(_context4) {
                    while(true)switch(_context4.prev = _context4.next){
                        case 0:
                            deduplicateActivities = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : true;
                            return _context4.abrupt("return", (0, $f4XZt.fetchActivitiesWithExperience)(function(experience) {
                                return _this.fetchActivitiesV3(experience, retryMS, filters, activityQueries, deduplicateActivities);
                            }, 'v3'));
                        case 2:
                        case "end":
                            return _context4.stop();
                    }
                }, _callee4);
            }));
            return function(_x5, _x6, _x7) {
                return _ref4.apply(this, arguments);
            };
        }());
        _this.clientHandlers = logger;
        _this.hydratorConfigClient = new (0, $kttmz.default)({
            captureException: _this.captureException,
            captureWarning: _this.captureWarning
        }, _product, configFetch);
        return _this;
    }
    (0, $5pRqT.default)(ActivityClientV3, _ActivityClient);
    return (0, $fCTsg.default)(ActivityClientV3);
}((0, $hqgpR.ActivityClient));
function $35526630329575d9$var$transformActivityItem(query, activities, hydrators, captureException) {
    return activities.reduce(function(acc, item) {
        if (item && item.node && item.node.object && item.node.event) {
            var _item$node = item.node, object = _item$node.object, event = _item$node.event;
            if (!object.product || !object.type) return acc;
            var containers = [];
            var c = object.contributors || [];
            var contributors = c.reduce(function(contributors, contributor) {
                if (contributor.profile) {
                    var _contributor$profile = contributor.profile, accountId = _contributor$profile.accountId, picture = _contributor$profile.picture;
                    contributors.push({
                        accountId: accountId,
                        name: contributor.profile.name,
                        picture: picture
                    });
                }
                return contributors;
            }, []);
            var hydratedData = (0, $cOEz4.hydratePolymorphicData)(hydrators, object.data, captureException);
            if (hydratedData) {
                var _object$data;
                if (hydratedData.key) containers.push({
                    name: (0, $lrhDf.hydratedValueToString)(hydratedData.key, ' ')
                });
                if (hydratedData.containers) containers.push({
                    name: (0, $lrhDf.hydratedValueToString)(hydratedData.containers, ' ')
                });
                var actor = event.actor ? {
                    name: event.actor.name,
                    picture: event.actor.picture,
                    accountId: event.actor.accountId
                } : undefined;
                // The V3 API returns "Created" for a new comment, we want this to display as "Commented"
                var eventType = object.type === 'comment' && event.eventType === (0, $fOIzk.WORKED_EVENT).CREATED ? (0, $fOIzk.WORKED_EVENT).COMMENTED : event.eventType;
                acc.push({
                    actor: actor,
                    query: query,
                    containers: containers,
                    contributors: contributors,
                    eventType: eventType,
                    object: {
                        rootContainerIdentifier: (0, $c53UJ.parseRootContainerARI)(object.rootContainerId),
                        icon: $35526630329575d9$var$CONFLUENCE_COMMENT_TYPENAMES.includes(object.data.__typename) ? (0, $lrhDf.hydrateConfluenceIcon)((_object$data = object.data) === null || _object$data === void 0 || (_object$data = _object$data.container) === null || _object$data === void 0 ? void 0 : _object$data.__typename, hydratedData.icon, hydratedData.staticFallbacks) : (0, $lrhDf.hydrateIcon)(hydratedData.icon, hydratedData.staticFallbacks),
                        id: object.id,
                        deduplicateId: (0, $lrhDf.hydratedValueToString)(hydratedData.deduplicateId) || object.id,
                        localResourceId: (0, $lrhDf.hydratedValueToString)(hydratedData.localResourceId),
                        name: (0, $lrhDf.hydratedValueToString)(hydratedData.name, ' '),
                        product: object.product,
                        subProduct: object.subProduct,
                        type: object.type,
                        url: (0, $lrhDf.hydratedValueToString)(hydratedData.url),
                        objectTypeName: (0, $lrhDf.hydratedValueToString)(hydratedData.objectTypeName)
                    },
                    timestamp: event.timestamp
                });
            }
        }
        return acc;
    }, []);
}

});
parcelRegister("9Cd3n", function(module, exports) {
$parcel$export(module.exports, "GraphQLFragmentError", function () { return $7001c9cbc41d3f0e$export$2d1b192199788179; });

var $fCTsg = parcelRequire("fCTsg");

var $aRrmH = parcelRequire("aRrmH");

var $6VWyZ = parcelRequire("6VWyZ");

var $bGqVi = parcelRequire("bGqVi");

var $5pRqT = parcelRequire("5pRqT");

var $7DNMr = parcelRequire("7DNMr");
function $7001c9cbc41d3f0e$var$_callSuper(t, o, e) {
    return o = (0, $bGqVi.default)(o), (0, $6VWyZ.default)(t, $7001c9cbc41d3f0e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $bGqVi.default)(t).constructor) : o.apply(t, e));
}
function $7001c9cbc41d3f0e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7001c9cbc41d3f0e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $7001c9cbc41d3f0e$export$2d1b192199788179 = /*#__PURE__*/ function(_Error) {
    function GraphQLFragmentError(message) {
        var _this;
        (0, $aRrmH.default)(this, GraphQLFragmentError);
        _this = $7001c9cbc41d3f0e$var$_callSuper(this, GraphQLFragmentError, [
            message
        ]);
        _this.name = 'GraphQLFragmentError';
        _this.message = message;
        return _this;
    }
    (0, $5pRqT.default)(GraphQLFragmentError, _Error);
    return (0, $fCTsg.default)(GraphQLFragmentError);
}(/*#__PURE__*/ (0, $7DNMr.default)(Error));

});

parcelRegister("8c5iM", function(module, exports) {
$parcel$export(module.exports, "GraphQLJSError", function () { return $5f738e96752f4ba1$export$8d4af49ee2a0fbe2; });

var $fCTsg = parcelRequire("fCTsg");

var $aRrmH = parcelRequire("aRrmH");

var $6VWyZ = parcelRequire("6VWyZ");

var $bGqVi = parcelRequire("bGqVi");

var $5pRqT = parcelRequire("5pRqT");

var $7DNMr = parcelRequire("7DNMr");
function $5f738e96752f4ba1$var$_callSuper(t, o, e) {
    return o = (0, $bGqVi.default)(o), (0, $6VWyZ.default)(t, $5f738e96752f4ba1$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $bGqVi.default)(t).constructor) : o.apply(t, e));
}
function $5f738e96752f4ba1$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5f738e96752f4ba1$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $5f738e96752f4ba1$export$8d4af49ee2a0fbe2 = /*#__PURE__*/ function(_Error) {
    function GraphQLJSError(graphQLError) {
        var _this;
        (0, $aRrmH.default)(this, GraphQLJSError);
        _this = $5f738e96752f4ba1$var$_callSuper(this, GraphQLJSError, [
            graphQLError.message
        ]);
        _this.name = 'GraphQLJSError';
        _this.error = graphQLError;
        _this.message = graphQLError.message;
        return _this;
    }
    (0, $5pRqT.default)(GraphQLJSError, _Error);
    return (0, $fCTsg.default)(GraphQLJSError);
}(/*#__PURE__*/ (0, $7DNMr.default)(Error));

});

parcelRegister("3MjIr", function(module, exports) {
$parcel$export(module.exports, "GraphQLNoResultsError", function () { return $2c0525eaf00c408b$export$3f19ff30d409b70; });

var $fCTsg = parcelRequire("fCTsg");

var $aRrmH = parcelRequire("aRrmH");

var $6VWyZ = parcelRequire("6VWyZ");

var $bGqVi = parcelRequire("bGqVi");

var $5pRqT = parcelRequire("5pRqT");

var $7DNMr = parcelRequire("7DNMr");
function $2c0525eaf00c408b$var$_callSuper(t, o, e) {
    return o = (0, $bGqVi.default)(o), (0, $6VWyZ.default)(t, $2c0525eaf00c408b$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $bGqVi.default)(t).constructor) : o.apply(t, e));
}
function $2c0525eaf00c408b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($2c0525eaf00c408b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $2c0525eaf00c408b$export$3f19ff30d409b70 = /*#__PURE__*/ function(_Error) {
    function GraphQLNoResultsError(graphQLErrors) {
        var _this;
        (0, $aRrmH.default)(this, GraphQLNoResultsError);
        _this = $2c0525eaf00c408b$var$_callSuper(this, GraphQLNoResultsError);
        _this.name = 'GraphQLNoResultsError';
        _this.errors = graphQLErrors;
        _this.message = 'GraphQL returned errors & no results';
        _this.errorMessages = graphQLErrors.map(function(error) {
            return error.message;
        });
        return _this;
    }
    (0, $5pRqT.default)(GraphQLNoResultsError, _Error);
    return (0, $fCTsg.default)(GraphQLNoResultsError);
}(/*#__PURE__*/ (0, $7DNMr.default)(Error));

});

parcelRegister("cOEz4", function(module, exports) {
$parcel$export(module.exports, "hydratePolymorphicData", function () { return $95499edad6196007$export$d658049bf1a63492; });

var $gFffs = parcelRequire("gFffs");

var $iy2hK = parcelRequire("iy2hK");

var $4EAwS = parcelRequire("4EAwS");

var $3904H = parcelRequire("3904H");
function $95499edad6196007$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $95499edad6196007$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $95499edad6196007$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gFffs.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $95499edad6196007$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $95499edad6196007$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $95499edad6196007$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $95499edad6196007$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $95499edad6196007$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $95499edad6196007$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $95499edad6196007$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $95499edad6196007$export$d658049bf1a63492 = function hydratePolymorphicData(hydrators, data, captureException) {
    if (data) {
        if ('__typename' in data) {
            var hydrator = hydrators[data.__typename];
            if (hydrator) try {
                return $95499edad6196007$var$hydrateData(data, hydrator);
            } catch (error) {
                captureException && captureException(new (0, $3904H.default)({
                    error: error,
                    message: "Hydrator failed for [".concat(data.__typename, "].")
                }));
            }
            else captureException && captureException(new (0, $3904H.default)({
                message: "Missing hydrator for [".concat(data.__typename, "].")
            }));
        } else captureException && captureException(new (0, $3904H.default)({
            message: "Missing [__typename] field from data."
        }));
    }
    return null;
};
function $95499edad6196007$var$getOrSearch(object, path) {
    if (!object) return object;
    if (path.includes(':')) {
        var _path$split = path.split(':'), _path$split2 = (0, $iy2hK.default)(_path$split, 2), searchField = _path$split2[0], searchValue = _path$split2[1];
        return $95499edad6196007$var$findNodeByField(object, searchField.trim(), searchValue.trim().replace(/"/g, '') // Strip any preceding whitesepace and quotes
        );
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($4EAwS)))(object, path);
}
function $95499edad6196007$var$resolvePath(object, path) {
    // Split the path on each bracket
    var splitPath = path.split(/\(|\)./);
    // Traverse the split path as a tree, resolving as we go
    var current = object;
    var _iterator = $95499edad6196007$var$_createForOfIteratorHelper(splitPath), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var split = _step.value;
            current = $95499edad6196007$var$getOrSearch(current, split);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return current;
}
function $95499edad6196007$var$findNodeByField(edges, fieldId, searchValue) {
    return edges.find(function(edge) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($4EAwS)))(edge, fieldId) === searchValue;
    });
}
function $95499edad6196007$export$a5c4301012ad6f07(object, paths) {
    return paths.map(function(path) {
        return $95499edad6196007$var$resolvePath(object, path);
    });
}
var $95499edad6196007$var$hydrateData = function hydrateData(data, hydrator) {
    var hydratorPaths = hydrator.hydratorPaths, staticFallbacks = hydrator.staticFallbacks;
    return $95499edad6196007$var$_objectSpread({
        staticFallbacks: staticFallbacks
    }, Object.entries(hydratorPaths).reduce(function(acc, _ref) {
        var _ref2 = (0, $iy2hK.default)(_ref, 2), key = _ref2[0], dataValue = _ref2[1];
        var item = $95499edad6196007$export$a5c4301012ad6f07(data, dataValue);
        if (item) acc[key] = item;
        else throw new Error("Bad hydrator path: ".concat(key));
        return acc;
    }, {}));
};

});
parcelRegister("3904H", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $24a2453857014c20$export$2e2bcd8739ae039; });

var $fCTsg = parcelRequire("fCTsg");

var $aRrmH = parcelRequire("aRrmH");

var $6VWyZ = parcelRequire("6VWyZ");

var $bGqVi = parcelRequire("bGqVi");

var $5pRqT = parcelRequire("5pRqT");

var $7DNMr = parcelRequire("7DNMr");
function $24a2453857014c20$var$_callSuper(t, o, e) {
    return o = (0, $bGqVi.default)(o), (0, $6VWyZ.default)(t, $24a2453857014c20$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $bGqVi.default)(t).constructor) : o.apply(t, e));
}
function $24a2453857014c20$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($24a2453857014c20$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $24a2453857014c20$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    function HydratorError(_ref) {
        var _this;
        var error = _ref.error, message = _ref.message;
        (0, $aRrmH.default)(this, HydratorError);
        _this = $24a2453857014c20$var$_callSuper(this, HydratorError);
        var err = error instanceof Error ? error : new Error();
        _this.name = 'HydratorError';
        _this.message = message;
        _this.originalMessage = err.message;
        _this.stack = err.stack;
        _this.originalName = err.name;
        return _this;
    }
    (0, $5pRqT.default)(HydratorError, _Error);
    return (0, $fCTsg.default)(HydratorError);
}(/*#__PURE__*/ (0, $7DNMr.default)(Error));

});


parcelRegister("lrhDf", function(module, exports) {
$parcel$export(module.exports, "hydratedValueToString", function () { return $f9b9cbf2c3d54fd8$export$c5cea44a1f75b431; });
$parcel$export(module.exports, "hydrateConfluenceIcon", function () { return $f9b9cbf2c3d54fd8$export$86b9f44277b105a6; });
$parcel$export(module.exports, "hydrateIcon", function () { return $f9b9cbf2c3d54fd8$export$a328b2bb0d21d984; });

var $bYF3k = parcelRequire("bYF3k");
var $f9b9cbf2c3d54fd8$export$c5cea44a1f75b431 = function hydratedValueToString(value) {
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    if (!value) return null;
    return Array.isArray(value) ? value.join(separator) : value;
};
function $f9b9cbf2c3d54fd8$var$isURL(icon) {
    return typeof icon === 'string';
}
function $f9b9cbf2c3d54fd8$var$isValidEmoji(icon) {
    return (0, $bYF3k.default)(icon) === 'object' && icon.value !== undefined && !!icon.value;
}
var $f9b9cbf2c3d54fd8$export$86b9f44277b105a6 = function hydrateConfluenceIcon(confluenceContainerType, icons, fallbacks) {
    switch(confluenceContainerType){
        case 'ConfluenceBlogPost':
            return $f9b9cbf2c3d54fd8$export$a328b2bb0d21d984(icons, fallbacks, 'confluenceBlogIcon') || $f9b9cbf2c3d54fd8$export$a328b2bb0d21d984(icons, fallbacks);
        case 'ConfluencePage':
            return $f9b9cbf2c3d54fd8$export$a328b2bb0d21d984(icons, fallbacks, 'confluencePageIcon') || $f9b9cbf2c3d54fd8$export$a328b2bb0d21d984(icons, fallbacks);
        default:
            return $f9b9cbf2c3d54fd8$export$a328b2bb0d21d984(icons, fallbacks);
    }
};
var $f9b9cbf2c3d54fd8$export$a328b2bb0d21d984 = function hydrateIcon(icons, fallbacks) {
    var fallbackKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'icon';
    if (Array.isArray(icons) && icons.length > 0) {
        var emojiIcons = icons.filter($f9b9cbf2c3d54fd8$var$isValidEmoji);
        if (emojiIcons.length > 0) return {
            type: 'EMOJI',
            value: emojiIcons[0].value,
            // return the first emoji
            fallback: fallbacks === null || fallbacks === void 0 ? void 0 : fallbacks[fallbackKey]
        };
        var urlIcons = icons.filter($f9b9cbf2c3d54fd8$var$isURL);
        if (urlIcons.length > 0) {
            var hydratedIcons = $f9b9cbf2c3d54fd8$export$c5cea44a1f75b431(urlIcons);
            if (hydratedIcons !== null) return {
                type: 'URL',
                value: hydratedIcons
            };
        }
    }
    if (fallbacks && fallbackKey in fallbacks && fallbacks[fallbackKey]) return {
        type: 'URL',
        value: fallbacks[fallbackKey]
    };
    return null;
};

});

parcelRegister("cCmIC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $92faa813afa41d46$export$2e2bcd8739ae039; });

var $ettkr = parcelRequire("ettkr");
var $92faa813afa41d46$var$errorHandlerMap = new Map([
    [
        'ValidationError',
        (0, $ettkr.default)
    ]
]);
var $92faa813afa41d46$var$graphQLErrorHandler = function graphQLErrorHandler(err) {
    var errorHandler = $92faa813afa41d46$var$errorHandlerMap.get(err.extensions.classification);
    if (typeof errorHandler === 'function') return errorHandler(err);
    return null;
};
var $92faa813afa41d46$export$2e2bcd8739ae039 = $92faa813afa41d46$var$graphQLErrorHandler;

});
parcelRegister("ettkr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a89a862b9fff41c6$export$2e2bcd8739ae039; });
/**
 * ^Validation error - look for validation errors from the start
 * .*?@ ' - look through everything up to the first instance of "@ '"
 * (\w+) - capture the first word, that's our invalid fragment
 */ var $a89a862b9fff41c6$var$captureRegex = new RegExp(/^Validation error.*?@ '(\w+)/);
var $a89a862b9fff41c6$var$validationErrorHandler = function validationErrorHandler(graphQLError) {
    var invalidFragmentMatch = $a89a862b9fff41c6$var$captureRegex.exec(graphQLError.message);
    if (Array.isArray(invalidFragmentMatch)) {
        var invalidFragment = invalidFragmentMatch[1];
        if (invalidFragment) return invalidFragment;
    }
    return null;
};
var $a89a862b9fff41c6$export$2e2bcd8739ae039 = $a89a862b9fff41c6$var$validationErrorHandler;

});


parcelRegister("gz827", function(module, exports) {
$parcel$export(module.exports, "generateGraphQLRequest", function () { return $c0f625712eba3002$export$7489a6ef09862e48; });

var $bHm7w = parcelRequire("bHm7w");

var $8UfbL = parcelRequire("8UfbL");

var $3MW3V = parcelRequire("3MW3V");
var $c0f625712eba3002$var$_excluded = [
    "limit"
];
var $c0f625712eba3002$var$ACTIVITIES_LIMIT = 50;
var $c0f625712eba3002$var$WORKED_ON_QUERY = "\n   workedOn(first: $first, filter: $filter) {\n     ...activityItemConnection\n   }\n";
var $c0f625712eba3002$var$VIEWED__QUERY = "\n   viewed(first: $first, filter: $filter) {\n     ...activityItemConnection\n   }\n";
var $c0f625712eba3002$var$ALL__QUERY = "\n    all(first: $first, filter: $filter) {\n      ...activityItemConnection\n    }\n";
var $c0f625712eba3002$var$activityQueryMap = new Map([
    [
        'workedOn',
        $c0f625712eba3002$var$WORKED_ON_QUERY
    ],
    [
        'viewed',
        $c0f625712eba3002$var$VIEWED__QUERY
    ],
    [
        'all',
        $c0f625712eba3002$var$ALL__QUERY
    ]
]);
var $c0f625712eba3002$var$getMyActivitiesQuery = function getMyActivitiesQuery(queries) {
    return "\n      myActivity {\n        ".concat(queries.join('\n'), "\n      }\n");
};
var $c0f625712eba3002$var$getActivitiesQuery = function getActivitiesQuery(product, content, fragments) {
    var activityFilterType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'ActivityFilter';
    return "\n    query ".concat((0, $8UfbL.getOperationName)(product), "($first: Int, $filter: ").concat(activityFilterType, ") {\n      activity {\n        ").concat(content, "\n      }\n    }\n").concat(fragments, "\n");
};
var $c0f625712eba3002$export$855cd08371c65b8c = function generateActivityQueryWithFilters(product, filters, activityQueries, fragments) {
    /**
   * If we are filtering by `actors` then we can't use the `myActivity` query.
   */ if (Array.isArray(filters.actors)) {
        // you can't view `viewed` events for other accounts
        var filteredAccountQueries = activityQueries.filter(function(query) {
            return query !== 'viewed';
        });
        return {
            query: $c0f625712eba3002$var$getActivitiesQuery(product, filteredAccountQueries.map(function(query) {
                return $c0f625712eba3002$var$activityQueryMap.get(query);
            }).join('\n'), fragments, 'ActivityFilter'),
            queryFilters: (0, $3MW3V.ACTIVITY_FILTER_COLLECTION).v3.get('activities')(filters)
        };
    } else return {
        query: $c0f625712eba3002$var$getActivitiesQuery(product, $c0f625712eba3002$var$getMyActivitiesQuery(activityQueries.map(function(query) {
            return $c0f625712eba3002$var$activityQueryMap.get(query);
        })), fragments, 'MyActivityFilter'),
        queryFilters: (0, $3MW3V.ACTIVITY_FILTER_COLLECTION).v3.get('myActivity')(filters)
    };
};
var $c0f625712eba3002$export$7489a6ef09862e48 = function generateGraphQLRequest(product, filters, activityQueries, fragments) {
    var _filters$limit = filters.limit, limit = _filters$limit === void 0 ? $c0f625712eba3002$var$ACTIVITIES_LIMIT : _filters$limit, restFilters = (0, $bHm7w.default)(filters, $c0f625712eba3002$var$_excluded);
    var _generateActivityQuer = $c0f625712eba3002$export$855cd08371c65b8c(product, restFilters, activityQueries, fragments), query = _generateActivityQuer.query, queryFilters = _generateActivityQuer.queryFilters;
    return {
        operationName: (0, $8UfbL.getOperationName)(product),
        query: query,
        variables: {
            first: limit,
            filter: queryFilters
        }
    };
};

});

parcelRegister("c53UJ", function(module, exports) {
$parcel$export(module.exports, "rollupActivitiesData", function () { return $8cb8fce410310d53$export$750d93207e30f59a; });
$parcel$export(module.exports, "activityRoot", function () { return $8cb8fce410310d53$export$ea55e8e0446efa94; });
$parcel$export(module.exports, "parseRootContainerARI", function () { return $8cb8fce410310d53$export$788e6013936a6bb4; });
$parcel$export(module.exports, "filtersToMetadata", function () { return $8cb8fce410310d53$export$e8f56bed6776c7ea; });
$parcel$export(module.exports, "filterInvalidFragments", function () { return $8cb8fce410310d53$export$e22863ec502608d2; });
$parcel$export(module.exports, "isEmptyActivitiesWithErrorsResponse", function () { return $8cb8fce410310d53$export$c939d6148e47244a; });

var $gFffs = parcelRequire("gFffs");

var $ivoqu = parcelRequire("ivoqu");
function $8cb8fce410310d53$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8cb8fce410310d53$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8cb8fce410310d53$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gFffs.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8cb8fce410310d53$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8cb8fce410310d53$export$750d93207e30f59a(activitiesData) {
    var all = activitiesData.all, viewed = activitiesData.viewed, workedOn = activitiesData.workedOn;
    return {
        all: $8cb8fce410310d53$var$rollUpActivityItems(all),
        viewed: $8cb8fce410310d53$var$rollUpActivityItems(viewed),
        workedOn: $8cb8fce410310d53$var$rollUpActivityItems(workedOn)
    };
}
function $8cb8fce410310d53$var$rollUpActivityItems(activityItems) {
    // https://stackoverflow.com/a/49460534
    // creates an ordered 'hashmap' containing unique ids in the same order that the activity items appear
    var latestActivityItemsObjectWithLatestTimestamp = activityItems.reduce(function(acc, activityItem) {
        var deduplicateId = activityItem.object.deduplicateId || activityItem.object.id;
        var existingItem = acc[deduplicateId];
        if (existingItem) {
            var aggregatedItems = existingItem.aggregatedActivityItems || [];
            if (Date.parse(existingItem.timestamp) < Date.parse(activityItem.timestamp)) {
                activityItem.aggregatedActivityItems = [].concat((0, $ivoqu.default)(aggregatedItems), [
                    existingItem
                ]);
                // remove the current activity for that id so when we add the more recent activity it is in the order that it appears
                delete acc[deduplicateId];
                acc[deduplicateId] = activityItem;
            } else acc[deduplicateId].aggregatedActivityItems = [].concat((0, $ivoqu.default)(aggregatedItems), [
                activityItem
            ]);
        } else acc[deduplicateId] = activityItem;
        return acc;
    }, {});
    return Object.values(latestActivityItemsObjectWithLatestTimestamp);
}
var $8cb8fce410310d53$export$213ba2e9f2d143b9 = function extractFragmentRegex(key) {
    return new RegExp("fragment ".concat($8cb8fce410310d53$var$fragmentName(key), " on ").concat($8cb8fce410310d53$var$fragmentType(key), " ({(.|\\n)+?(?=fragment))"), 'gm');
};
var $8cb8fce410310d53$var$fragmentName = function fragmentName(key) {
    return key.charAt(0).toLowerCase() + key.slice(1);
};
var $8cb8fce410310d53$var$fragmentType = function fragmentType(key) {
    return key.charAt(0).toUpperCase() + key.slice(1);
};
var $8cb8fce410310d53$export$ea55e8e0446efa94 = function activityRoot(activity) {
    if (activity.myActivity) return activity.myActivity;
    return activity;
};
var $8cb8fce410310d53$var$SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
var $8cb8fce410310d53$var$containerMapTypes = new Map([
    [
        $8cb8fce410310d53$var$SITE_ARI_PREFIX,
        'SITE'
    ]
]);
function $8cb8fce410310d53$export$788e6013936a6bb4(rootContainerARI) {
    // the "ID" portion of the ARI begins after the first '/'
    var ariSplitIndex = rootContainerARI.indexOf('/');
    return {
        ari: rootContainerARI,
        id: rootContainerARI.slice(ariSplitIndex + 1),
        type: $8cb8fce410310d53$var$containerMapTypes.get(rootContainerARI.slice(0, ariSplitIndex + 1)) || 'OTHER'
    };
}
function $8cb8fce410310d53$export$e8f56bed6776c7ea(filters) {
    var _filters$actors, _filters$containerIds, _filters$products, _filters$eventTypes, _filters$objectTypes, _filters$rootContaine;
    return $8cb8fce410310d53$var$_objectSpread($8cb8fce410310d53$var$_objectSpread({}, filters), {}, {
        // These have V high cardinality, so using a length
        actors: (_filters$actors = filters.actors) === null || _filters$actors === void 0 ? void 0 : _filters$actors.length,
        containerIds: (_filters$containerIds = filters.containerIds) === null || _filters$containerIds === void 0 ? void 0 : _filters$containerIds.length,
        // comma separated lists
        products: (_filters$products = filters.products) === null || _filters$products === void 0 ? void 0 : _filters$products.join(','),
        eventTypes: (_filters$eventTypes = filters.eventTypes) === null || _filters$eventTypes === void 0 ? void 0 : _filters$eventTypes.join(','),
        objectTypes: (_filters$objectTypes = filters.objectTypes) === null || _filters$objectTypes === void 0 ? void 0 : _filters$objectTypes.join(','),
        rootContainerIds: (_filters$rootContaine = filters.rootContainerIds) === null || _filters$rootContaine === void 0 ? void 0 : _filters$rootContaine.join(',')
    });
}
/**
 * These fragments are the core of our query, without them it will always fail,
 * so we shouldn't remove them. It is possible that removing other offending fragments
 * will fix the error in these core fragments. (e.g. Field conflict)
 */ var $8cb8fce410310d53$var$RESTRICTED_FRAGMENTS = [
    'activity',
    'all',
    'myActivity',
    'workedOn',
    'viewed',
    'activityItemConnection',
    'activityItemEdge'
];
function $8cb8fce410310d53$export$e22863ec502608d2(invalidFragments, allFragments) {
    return invalidFragments.filter(function(fragment) {
        return !$8cb8fce410310d53$var$RESTRICTED_FRAGMENTS.includes(fragment);
    }).reduce(function(acc, invalidFragment) {
        return acc.replace(new RegExp("...".concat(invalidFragment, "\n"), 'g'), '').replace($8cb8fce410310d53$export$213ba2e9f2d143b9(invalidFragment), '');
    }, allFragments);
}
var $8cb8fce410310d53$var$IGNORED_ERROR_CLASSIFICATIONS = [
    'IncorrectAuthException'
];
function $8cb8fce410310d53$export$c939d6148e47244a(response) {
    if (!(response !== null && response !== void 0 && response.data) || !Array.isArray(response.errors)) return false;
    var filteredAggErrors = response.errors.filter(function(e) {
        return !e.extensions.classification || !$8cb8fce410310d53$var$IGNORED_ERROR_CLASSIFICATIONS.includes(e.extensions.classification);
    });
    return filteredAggErrors.length > 0 && $8cb8fce410310d53$export$884573c560ed3600(response.data);
}
function $8cb8fce410310d53$export$884573c560ed3600(queryData) {
    var _activityRoot$all, _activityRoot$workedO, _queryData$activity;
    return !queryData.activity || ((_activityRoot$all = $8cb8fce410310d53$export$ea55e8e0446efa94(queryData.activity).all) === null || _activityRoot$all === void 0 || (_activityRoot$all = _activityRoot$all.edges) === null || _activityRoot$all === void 0 ? void 0 : _activityRoot$all.length) === 0 && ((_activityRoot$workedO = $8cb8fce410310d53$export$ea55e8e0446efa94(queryData.activity).workedOn) === null || _activityRoot$workedO === void 0 || (_activityRoot$workedO = _activityRoot$workedO.edges) === null || _activityRoot$workedO === void 0 ? void 0 : _activityRoot$workedO.length) === 0 && ((_queryData$activity = queryData.activity) === null || _queryData$activity === void 0 || (_queryData$activity = _queryData$activity.myActivity) === null || _queryData$activity === void 0 || (_queryData$activity = _queryData$activity.viewed) === null || _queryData$activity === void 0 || (_queryData$activity = _queryData$activity.edges) === null || _queryData$activity === void 0 ? void 0 : _queryData$activity.length) === 0;
}

});




parcelRegister("bUqvj", function(module, exports) {
$parcel$export(module.exports, "AvatarIcon", function () { return $e312a6f2d047eb18$export$b1f22795a41806ac; });
$parcel$export(module.exports, "AvatarFacepile", function () { return $e312a6f2d047eb18$export$ca915dc6aced2b3e; });
/* avatar-facepile.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $imIsw = parcelRequire("imIsw");

var $kbpa7 = parcelRequire("kbpa7");
const $e312a6f2d047eb18$export$b1f22795a41806ac = ({ icon: icon, iconSize: iconSize, overlap: overlap })=>{
    const iconStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: icon,
            alt: "avatar",
            width: iconSize,
            height: iconSize
        },
        className: (0, $2jatx.default)([
            "_2rko1wqb _1e0c1o8l _4t3ibv8l _ahbq1bmj _1reo15vq _18m915vq _kqswh2mm _1bsbbv8l _rtqb8nf5"
        ]),
        style: {
            "--_1lwyf0k": (0, $6ZVlx.default)(iconSize, "px"),
            "--_19zwya0-": (0, $6ZVlx.default)(overlap, "px", "-")
        }
    });
};
const $e312a6f2d047eb18$export$ca915dc6aced2b3e = ({ icons: icons, max: max, overlap: overlap = 4, iconSize: iconSize = 16 })=>{
    const userCountPillStyles = null;
    const facepileStyles = [
        null,
        overlap > 0 && null
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c116y _4t3ibv8l _1bsb1osq _9e7b1bmj",
            overlap > 0 && "_ahbqccqr"
        ]),
        style: {
            "--_1lwyf0k": (0, $6ZVlx.default)(iconSize, "px"),
            "--_19zwya0-": (0, $6ZVlx.default)(overlap, "px", "-"),
            "--_19zwya0": (0, $6ZVlx.default)(overlap, "px")
        },
        children: [
            icons.slice(0, max).map((icon, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)($e312a6f2d047eb18$export$b1f22795a41806ac, {
                    icon: icon,
                    iconSize: iconSize,
                    overlap: overlap
                }, index)),
            icons.length > max && /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                className: (0, $2jatx.default)([
                    "_4cvr1h6o _2rko1k4y _19it1dxc _syaz1yg0 _1e0c116y _1wybgbje _k48p1nn1 _zulpze3t _4t3ibv8l _1bah1h6o _vwz4bv8l _ahbq1564 _1yt418uk _y3gn1h6o _s7n4nkob _1bsb1wug"
                ]),
                style: {
                    "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800")),
                    "--_1lwyf0k": (0, $6ZVlx.default)(iconSize, "px"),
                    "--_1j20svt": (0, $6ZVlx.default)(overlap * -1, "px")
                },
                children: [
                    "+",
                    icons.length - max
                ]
            })
        ]
    });
};

});


//# sourceMappingURL=index.bf5adf84.js.map
